import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { saveAs } from "file-saver";
import nodataimage from "../../images/Group 123068.svg";
import { toVariableNameFormat } from "../../Helper/Helper";
import {
  Box,
  Container,
  FormControlLabel,
  FormGroup,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AccordionComp, { Accordion } from "../utilities/Accordian/Accordian";
import SearchIcon from "@mui/icons-material/Search";
import {
  CreateRequestWrapper,
  ViewBoxWrapper,
  CalculationWrapper,
} from "./QuoteRequeststyled";
import {
  Content,
  CheckboxLabels,
  Constant,
  OpportunityType,
  ProductList,
  QuoteStatus,
  UserRole,
  ProductsEnum,
  DiscountToolTip,
  NoOfRamsToolTip,
  samPricingToolTip,
  renewalToolTip,
  BankOfHoursComponentsEnum,
  LocalStorageKeys,
  AllProductsEnum,
  PricingStructuresEnum,
  CalculatedProducts,
  BOHComponentPricingStructureMap,
  BankOfHoursComponentMappingMasterArray,
  COUNTRIES_WORKLIFE,
  COUNTRIES_TOTALSOURCE,
  COUNTRIES_EVOLUTION,
  isProductLikeBOH,
  isProductNotLikeBOH,
  BundleDiscountToolTip,
} from "./Content";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomButton from "../utilities/Button/Button";
import Button from "@mui/material/Button";
import Banner from "../utilities/Banner/Banner";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import SaveIcon from "@mui/icons-material/Save";
import ViewTable from "../utilities/ViewTable/ViewTable";
import Checkbox from "@mui/material/Checkbox";
import FooterButtons from "../utilities/FooterButtons/FooterButton";
import Validation from "../../Helper/Validation";
import Notification from "../utilities/Notification/Notification";
import InputAdornment from "@mui/material/InputAdornment";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CheckIcon from "@mui/icons-material/Check";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useSelector, useDispatch } from "react-redux";
import { Congiguration } from "../../Constants/AppConstants";
import {
  saveOpportunityDetails,
  saveCountryHeadCount,
  validateCountryHeadCount,
  getAllInPrice,
  saveQuoteDetails,
  getServiceDistribution,
  saveServiceDistribution,
  getQuoteDetails,
  getDuplicateQuoteDetails,
  getQuoteCountryHeadCounts,
  SaveQuoteCalculationsNonEAP,
  removeQuoteCountries,
  uploadRFPFile,
  downloadRFPFile,
} from "../../Actions/QuoteAction";
import { getProductDetails } from "../../Actions/ProductAction";
import moment from "moment";
import { constant, difference, differenceBy, get, isEmpty } from "lodash";
import { read, utils } from "xlsx";
import { useNavigate } from "react-router-dom";
import ServiceDistribution from "./ServiceDistribution";
import { Severity } from "../utilities/Notification/NotificationContent";
import ValidationAccordionComp from "../utilities/ValidationAccordion/ValidationAccordian";
import UploadCountriesTemplatexlsx from "../QuoteRequest/UploadCountriesTemplate.xlsx";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import RedoOutlinedIcon from "@mui/icons-material/RedoOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import AddIcon from "@mui/icons-material/Add";
import SimpleDialog from "../utilities/Dialog/SimpleDialog";
import ViewCountryDialog from "../utilities/ViewCountryDialog/ViewCountryDialog";
import UtilizationDistribution from "./UtilizationDistribution ";
import { sendEmailToStakeHolders } from "../../Actions/CommonAction";
import { Link } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import { green } from "@mui/material/colors";
import Loader from "../utilities/Loader/Loader";
import { getLoggedUserDetails } from "../../Actions/UserAction";
import {
  addCountryHeadcount,
  getCRMDataDetails,
  getCrmPopulationUploadData,
} from "../../Actions/CRMAction";
import { parse } from "qs";
import { isJsonString } from "../../Helper/Helper";
import {
  GET_CRM_DATA,
  GET_LOGGED_USER_DETAILS,
  UPDATE_CRM_DATA,
} from "../../ActionTypes/ActionTypes";
import ConfirmationBox from "./ConfirmationBox";
import SearchInput from "../utilities/SearchInput/SearchInput";
//#region constant

let quote = {
  quoteId: "",
  oppurtunityId: "",
  oppurtunity: "",
  oppurtunityName: "",
  quoteName: "",
  accountName: "",
  accountId: "",
  oppurtunityType: "",
  member: "",
  referrerName: "",
  commission: 0,
  percentagePaid: 0,
  discount: 0,
  bundleDiscount: 0,
  currencyId: 0,
  existingPartneredClientInfo: "",
  noOfLivesSavedByPartner: "",
  totalPotentialHeadCountOutside: "",
  formalRFPNotes: "",
  competitorsBidders: "",
  pastQuotes: "",
  currentUtilizationWithOtherVendors: "",
  deadline: null,
  noOfRAMs: "",
  locationRAMs: "",
  samPriceRecommendAssumption: "",
  productId: 0,
  productVariationId: 0,
  componentIds: "",
  sessions: 0,
  utilization: 0,
  pricingStructureId: 0,
  hours: 0,
  rfpFileName: null,
  additionalNotes: "",
  currentRateEffectiveOn: "",
  pastThreeYrRateHeadCount: "",
  estimatedNoOfAMHrPerYear: "",
  annualUtilizationThreeYrs: "",
  quoteStatusId: 0,
  accountManagerName: "",
  amHours: "",
  userId: 0,
  seatCount: 0,
  companyId: 0,
  isDiscount: false,
  ucmsId: "",
  numberOfYears: 1,
};

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const nonEapHeader = [
  {
    id: "revenueStage1ReqCurrency",
    label: "Revenue Stage 1 Req Currency",
    isEditable: true,
  },
  { id: "revenueStage1USD", label: "Revenue Stage 1 USD", isEditable: true },
  {
    id: "revenueStage2ReqCurrency",
    label: "Revenue Stage 2 Req Currency",
    isEditable: true,
  },
  { id: "revenueStage2USD", label: "Revenue Stage 2 USD", isEditable: true },
  { id: "revenueStage3ReqCurrency", label: "Revenue Stage 3 Req Currency" },
  { id: "revenueStage3USD", label: "Revenue Stage 3 USD" },
  { id: "revenueStage4ReqCurrency", label: "Revenue Stage 4 Req Currency" },
  { id: "revenueStage4USD", label: "Revenue Stage 4 USD" },
  { id: "revenueStage5ReqCurrency", label: "Revenue Stage 5 Req Currency" },
  { id: "revenueStage5USD", label: "Revenue Stage 5 USD" },
  { id: "pepyReqCurrency", label: "PEPY Req Currency" },
  { id: "pepyusd", label: "PEPY USD" },
  { id: "pepmReqCurrency", label: "PEPM Req Currency" },
  { id: "pepmusd", label: "PEPM USD" },
  { id: "flatFeeMonthlyReqCurrency", label: "Flat Fee Monthly Req Currency" },
  { id: "flatFeeMonthlyUSD", label: "Flat Fee Monthly USD" },
  { id: "flatFeeAnnualReqCurrency", label: "Flat Fee Annual Req Currency" },
  { id: "flatFeeAnnualUSD", label: "Flat Fee Annual USD" },
  { id: "ffsReqCurrency", label: "FFS Req Currency", isEditable: true },
  { id: "ffsAnnualUSD", label: "FFS Annual USD", isEditable: true },
];
const nonEapRows = [
  {
    ffsAnnualUSD: 0,
    ffsReqCurrency: 0,
    flatFeeAnnualReqCurrency: 0,
    flatFeeAnnualUSD: 0,
    flatFeeMonthlyReqCurrency: 0,
    flatFeeMonthlyUSD: 0,
    pepmReqCurrency: 0,
    pepmusd: 0,
    pepyReqCurrency: 0,
    pepyusd: 0,
    revenueStage1ReqCurrency: 0,
    revenueStage1USD: 0,
    revenueStage2ReqCurrency: 0,
    revenueStage2USD: 0,
    revenueStage3ReqCurrency: 0,
    revenueStage3USD: 0,
    revenueStage4ReqCurrency: 0,
    revenueStage4USD: 0,
    tcvcad: 0,
  },
];
const nonEapInital = {
  ffsAnnualUSD: 0,
  ffsReqCurrency: 0,
  revenueStage1ReqCurrency: 0,
  revenueStage1USD: 0,
  revenueStage2ReqCurrency: 0,
  revenueStage2USD: 0,
};
const countryRows = [{ countryName: "", headcount: 0 }];

//Defined for variation section for now, should extend for all fields
const fieldIsVisibleObj = {
  SESSION: true,
  UTILIZATION: true,
  PRICINGSTRUCTURE: true,
  HOURS: true,
  AMHOURS: true,
  SEATCOUNT: true,
  DISCOUNT: true,
  ADDITIONALNOTES: true,
  BUNDLEDISCOUNT: true,
};

//#endregion
const QuoteRequest = () => {
  //#region constants
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const useremail = sessionStorage.getItem(LocalStorageKeys.USEREMAIL);
  const loggedUserLocalStorage = isJsonString(
    sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER),
  )
    ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
    : null;
  const crmDataLocalStorage = isJsonString(
    sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL),
  )
    ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL))
    : null;

  let loggedUser = useSelector((state) => state?.UserReducer?.loggedUser);
  let crmData = useSelector((state) => state?.CRMReducer?.crmData);

  if (
    loggedUser !== undefined &&
    Object.keys(loggedUser).length === 0 &&
    loggedUser.constructor === Object &&
    loggedUserLocalStorage !== null
  ) {
    loggedUser = loggedUserLocalStorage;
    if (useremail?.toUpperCase() !== loggedUser?.user?.email?.toUpperCase()) {
      dispatch(getLoggedUserDetails(useremail))
        .then((response) => {
          loggedUser = response;
          //storing user login to reducer
          dispatch({
            type: GET_LOGGED_USER_DETAILS,
            payload: response,
          });
        })
        .catch((error) => {
          console.log(`userEmail : ${useremail} error : ${error}`);
        });
    } else {
      //storing user login to reducer
      dispatch({
        type: GET_LOGGED_USER_DETAILS,
        payload: loggedUser,
      });
    }
  } else if (
    loggedUser !== undefined &&
    Object.keys(loggedUser).length !== 0 &&
    loggedUser.constructor === Object &&
    loggedUserLocalStorage !== null
  ) {
    loggedUser = loggedUserLocalStorage;
    if (useremail?.toUpperCase() !== loggedUser?.user?.email?.toUpperCase()) {
      dispatch(getLoggedUserDetails(useremail))
        .then((response) => {
          loggedUser = response;
          const jsonUserData = JSON.stringify(response);
          sessionStorage.setItem(LocalStorageKeys.LOGGEDUSER, jsonUserData);
          //storing user login to reducer
          dispatch({
            type: GET_LOGGED_USER_DETAILS,
            payload: response,
          });
        })
        .catch((error) => {
          console.log(`userEmail : ${useremail} error : ${error}`);
        });
    }
  }

  if (
    crmData !== undefined &&
    Object.keys(crmData).length === 0 &&
    crmData.constructor === Object &&
    crmDataLocalStorage !== null
  ) {
    crmData = crmDataLocalStorage;
    //storing CRM data to reducer
    dispatch({
      type: GET_CRM_DATA,
      payload: crmData,
    });
  }

  const userEmailLocalStorage = sessionStorage.getItem(
    LocalStorageKeys.USEREMAIL,
  );
  const opportunityLocalStorage = sessionStorage.getItem(
    LocalStorageKeys.OPPORTUNITYID,
  );

  if (isEmpty(loggedUser)) {
    if (userEmailLocalStorage) {
      dispatch(getLoggedUserDetails(userEmailLocalStorage))
        .then((data) => {
          console.log("user details", data);
          loggedUser = data;
        })
        .catch((e) => {
          console.log("error fetching user details", e);
        });
    }
  }

  if (isEmpty(crmData)) {
    if (opportunityLocalStorage) {
      dispatch(getCRMDataDetails(opportunityLocalStorage))
        .then((data) => {
          console.log("opportunity details", data);
          crmData = data;
        })
        .catch((e) => {
          console.log("error fetching opportunity details", e);
        });
    }
  }

  const [countryUtilizationVariation, setcountryUtilizationVariation] =
    useState(null);
  const [isUtilizationChanged, setIsUtilizationChanged] = useState(false);
  const [fieldIsVisible, setFieldIsVisible] = useState({
    ...fieldIsVisibleObj,
  });
  const [formValues, setFormValues] = useState({ ...quote });
  const [productDetails, setProductDetails] = useState({});
  const [productsList, setProductsList] = useState([]);
  const [productVariationsList, setProductVariationsList] = useState([]);
  const [pricingStructureList, setPricingStructureList] = useState([]);
  const [componentList, setComponentList] = useState([]);
  const [showVariationAccordian, setShowVariationAccordian] = useState(false);
  const [editMode, setEditMode] = useState(true);
  const [isRowUpdated, setIsRowUpdate] = useState(false);
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [pricingStructureLbl, setPricingStructureLbl] = useState("");
  const [pricingStructureUSDLbl, setPricingStructureUSDLbl] = useState("");
  const [pricingStructureVal, setPricingStructureVal] = useState("");
  const [pricingStructureUSDVal, setPricingStructureUSDVal] = useState("");
  const [tcvCad, setTcvCad] = useState("");

  const [errors, setErrors] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationSeverity, setNotificationSeverity] = useState("");

  const [utilizationDistributionRows, setUtilizationDistributionRows] =
    useState([]);
  const [
    utilizationDistributionCountries,
    setUtilizationDistributionByCountries,
  ] = useState([]);
  const [isDistributionEditable, setIsDistributionEditable] = useState(false);
  const [isAccordianExpanded, setIsAccordianExpanded] = useState(
    crmData?.populationDetails !== null,
  );
  const [isAccordianDisabled, setIsAccordianDisabled] = useState(
    crmData?.populationDetails == null,
  );

  const [renderKey, setRenderKey] = useState(0);
  const [serviceDistributionList, setServiceDistributionList] = useState([]);
  const [oldServiceDistributionList, setoldServiceDistributionList] = useState(
    [],
  );
  const [utilizationDistributionOriginal, setutilizationDistributionOriginal] =
    useState([]);
  const [isValidCountriesUpload, setisValidCountriesUpload] = useState(true);
  const [countryValidationHeaders, setCountryValidationHeaders] = useState([]);
  const [countryValidationRows, setCountryValidationRows] = useState([]);
  const [countryValidationCountries, setCountryValidationCountries] = useState(
    [],
  );
  const [isCountriesFileUploaded, setIsCountriesFileUploaded] = useState(false);
  const [countryUploadFileName, setCountryUploadFileName] = useState("");
  const [countryHeadCountDialogRows, setCountryHeadCountDialogRows] =
    useState(countryRows);
  const [showCountryHeadCountDialog, setShowCountryHeadCountDialog] =
    useState(false);
  const [showCountryDialog, setShowCountryDialog] = useState(false);

  const [isDiscountApplied, setIsDiscountApplied] = useState(false);
  const [
    isPricingTeamApproveRejectDiscount,
    setIsPricingTeamApproveRejectDiscount,
  ] = useState(false);
  const [currentQuoteStatusId, setCurrentQuoteStatusId] = useState(0);
  const [existingDiscountValue, setExistingDiscountValue] = useState(0);
  const [duplicateCountryList, setDuplicateCountryList] = useState([]);
  const [nonEapData, setNonEapData] = useState(nonEapInital);
  const [isNonEapEditable, setIsNonEapEditable] = useState(false);
  const [nonEapRowData, setNonEapRows] = useState(nonEapRows);
  const [selectedFile, setSelectedFile] = useState(null);

  const [calculateBtnLoading, setCalculateBtnLoading] = useState(false);
  const [allInPriceLoading, setAllInPriceLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading please wait");
  const [breadCrumbName, setBreadCrumbName] = useState("");
  const [showButtons, setShowButtons] = useState(true);
  const [newCountryHeadCount, setNewCountryHeadCount] = useState();
  const [newHeadcountError, setNewHeadcountError] = useState("");
  const [newCountryError, setNewCountryError] = useState("");
  const [allCountrylist, setallCountrylist] = useState([]);
  const [commissionPercentageValue, setCommissionPercentageValue] =
    useState(null);
  const [isConsultingITDevShowCalculate, setIsConsultingITDevShowCalculate] =
    useState(true);
  const [isConsultingITDevShowNonEAPGrid, setIsConsultingITDevShowNonEAPGrid] =
    useState(false);
  const [quoteLoader, setQuoteLoader] = useState(false);

  const countryValidationTitle = "Validation Error:";
  const countryValidationSubTitle = "Please Correct Errors";
  const countryValidationHeadersValues = [
    "Country",
    "HeadCount",
    "CPQ Correction",
    "CPQ Error",
  ];

  const countryHeadCountDialogHeaders = [
    { id: "countryName", label: "Countries" },
    { id: "headcount", label: "Total Head Count" },
  ];

  let bannerName = "";
  let bannerDescription = "";

  if (state.requestType === "Create") {
    bannerName = Constant.BANNER_HEADING;
    bannerDescription = Constant.BANNER_PARAGRAPH;
    document.title = "Create Request";
  } else if (state.requestType === "Edit") {
    bannerName = Constant.BANNER_HEADING_EDIT;
    bannerDescription = Constant.BANNER_PARAGRAPH_EDIT;
    document.title = "Edit Request";
  } else if (state.requestType === "Duplicate") {
    bannerName = Constant.BANNER_HEADING_DUPLICATE;
    bannerDescription = Constant.BANNER_PARAGRAPH_DUPLICATE;
    document.title = "Duplicate Request";
  }

  const [FormHeading, setFormHeading] = useState(Constant.FORM_HEADING1);
  const [sumHeadCounts, setSumHeadCounts] = useState(null);
  const [countryHeadCountList, setCountryHeadCountList] = useState(null);
  const [showCommentText, setShowCommentText] = useState(false);
  const [submitclick, setSubmit] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [quoteObject, setQuoteObject] = useState({});
  const [actionDone, setActionDone] = useState("");
  const [isDiscountUpdated, setIsDiscountUpdated] = useState(false);
  const [quoteStatus, setQuoteStatus] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [optype, setOpType] = useState(
    OpportunityType.find(
      (x) =>
        x.crmOpportunityType === crmData.opportunityType ||
        x.crmOpportunityType === crmData.oppurtunityType,
    ),
  );

  if (!crmData.opportunityType && !crmData.oppurtunityType) {
    console.log(
      "Error OpportunityType mapping is not present in CPQ",
      crmData.opportunityType
        ? crmData.opportunityType
        : crmData.oppurtunityType,
    );
  } else {
    console.log(
      "OpportunityType",
      crmData.opportunityType
        ? crmData.opportunityType
        : crmData.oppurtunityType,
    );
  }
  const [opportunityType, setOpportunityType] = useState(
    optype?.cpqOpportunityType,
  );
  const [crmDataFromSessionStorage, setCrmDataFromSessionStorage] = useState(
    sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL),
  );
  //#endregion

  //#region initialization methods

  useEffect(() => {
    window.scrollTo(0, 0);
    sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, "Create Request");
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    console.log("Updated isDiscount: ", isDiscountApplied);
    const condition =
      state?.requestType === "Edit" &&
      isDiscountApplied &&
      (loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM || 
        loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER || 
        loggedUser?.userRole[0]?.id === UserRole.PRICINGVP);

    console.log(condition, "Pricing team dicount approve condition");
    setIsPricingTeamApproveRejectDiscount(condition);
  }, [isDiscountApplied]);

  useEffect(() => {
    setCurrentQuoteStatusId(formValues.quoteStatusId);
  }, [formValues]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      console.log("reload performed");
      //alert(`Current working Opportunity defaulted to ${crmData.opportunityName}`);
      if (
        (state?.requestType === "Create" ||
          state?.requestType === "Duplicate") &&
        crmData?.oppurtunityId
      ) {
        //refresh crm data
        //CHECKIFREQ
        dispatch(getCRMDataDetails(crmData?.oppurtunityId))
          .then((data) => {
            console.log("CRM data refreshed", data);
            sessionStorage.removeItem(LocalStorageKeys.CRMDATAINITIAL);
            const jsonCRMData = JSON.stringify(data);
            sessionStorage.setItem(
              LocalStorageKeys.CRMDATAINITIAL,
              jsonCRMData,
            );
            setOpType(
              OpportunityType.find(
                (x) => x.crmOpportunityType === data?.opportunityType,
              ),
            );
          })
          .catch((e) => {
            console.log(e);
          });
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (loggedUser && loggedUser?.userRole && crmData) {
      formValues.quoteStatusId = QuoteStatus.SAVEASDRAFT;
      setLoadingState(true);
      console.log(loggedUser.userRole, "logged user role");

      if (state?.requestType === "Create") {
        CreateNewQuoteRequest();
        if (crmData?.populationDetails === null) {
          setShowButtons(false);
          setLoadingState(false);
        }
        setBreadCrumbName(Constant.BREADCRUMB_NAME_CREATE);
      }

      if (state?.requestType === "Edit") {
        EditQuoteRequest();
        setBreadCrumbName(Constant.BREADCRUMB_NAME_EDIT);
      }

      if (state?.requestType === "Duplicate") {
        setCommissionPercentageValue(crmData?.commissionPercentage);
        if (crmData?.populationDetails === null) {
          setShowButtons(false);
          setLoadingState(false);
        } else {
          //DuplicateQuoteRequest();
          setFormHeading(Constant.FORM_HEADING);
          const countryHeadCount = {
            countryHeadCountType: crmData.populationDetails.map((item) => {
              return {
                countryName: item.country,
                headCount: item.headCount,
              };
            }),
            oppurtunityId: crmData.opportunityId,
            userId: loggedUser.user.id,
            companyId: Congiguration.CompanyId,
          };
          UploadCountries(countryHeadCount);
        }
        setBreadCrumbName(Constant.BREADCRUMB_NAME_DUPLICATE);
      }
    }
  }, []);

  const handleSearch = (event) => {
    setSearchQuery(event?.target?.value);
  };

  //#region  functions

  function saveOpportunityAndHeadCountFromCRM(formattedDate) {
    setOpType(
      OpportunityType.find(
        (x) => x.crmOpportunityType === crmData.opportunityType,
      ),
    );

    const opportunity = {
      oppurtunityId: crmData.opportunityId,
      oppurtunity: crmData.opportunity,
      oppurtunityName: crmData.opportunityName,
      oppurtunityType: optype?.cpqOpportunityType
        ? optype?.cpqOpportunityType
        : OpportunityType.find(
            (x) => x.crmOpportunityType === crmData.opportunityType,
          ).cpqOpportunityType,
      oppurtunityReferrerName: crmData.opportunityReferrerName,
      accountName: crmData.account,
      billingCountry: crmData.billingCountry,
      programStartDate: formattedDate,
      commissionPercent: crmData.commissionPercentage
        ? crmData.commissionPercentage.toString()
        : "",
      isBroker: crmData.isBroker === "Yes",
      memberOf: crmData.wpo_memberoftext,
      currencyCode: crmData.currencyCode,
      accountSubType: crmData.accountSubType,
      accountOwner: crmData.accountOwner,
      accountOwnerEmail: crmData.accountOwnerMail,
      opportunitySaleLead: crmData.opportunitySaleLead,
      saleLeadEmail: crmData?.opportunitySaleLeadEmail,
      opportunityAmLead: crmData.opportunityAmLead,
      amLeadEmail: crmData?.opportunityAmLeadEmail,
      opportunityIsAdditionalTeamMember:
        crmData.opportunityIsAdditionalTeamMember === "Yes",
      opportunityAdditionTeamMember: crmData.opportunityAdditionTeamMember,
      additionTeamMemberEmail: crmData?.opportunityAdditionTeamMemberEmail,
      companyId: Congiguration.CompanyId,
      ucmsId: crmData?.ucmsId,
      userId: loggedUser.user.id,
    };
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      oppurtunityId: crmData.opportunityId,
      userId: loggedUser.user.id,
      companyId: Congiguration.CompanyId,
      accountName: crmData.account,
      oppurtunityType: optype?.cpqOpportunityType,
      commission: crmData.commissionPercentage
        ? crmData.commissionPercentage.toString()
        : 0,
      ucmsId: crmData?.ucmsId,
    }));
    setCommissionPercentageValue(crmData.commissionPercentage);

    dispatch(saveOpportunityDetails(opportunity))
      .then((data) => {
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          currencyId: data,
          oppurtunityId: crmData.opportunityId,
          userId: loggedUser.user.id,
          companyId: Congiguration.CompanyId,
          accountName: crmData.account,
        }));
        if (
          (state?.requestType === "Create" ||
            state?.requestType === "Duplicate") &&
          crmData?.populationDetails !== null
        ) {
          setFormHeading(Constant.FORM_HEADING);
          const countryHeadCount = {
            countryHeadCountType: crmData.populationDetails.map((item) => {
              return {
                countryName: item.country,
                headCount: item.headCount,
                region: item.region,
              };
            }),
            oppurtunityId: crmData.opportunityId,
            userId: loggedUser.user.id,
            companyId: Congiguration.CompanyId,
          };
          UploadCountries(countryHeadCount);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  function CreateNewQuoteRequest() {
    const myDate =
      moment(crmData.programStartDate).format("YYYY-MM-DDT00:00:00.000") + "Z";
    saveOpportunityAndHeadCountFromCRM(myDate);

    if (isEmpty(productDetails)) {
      dispatch(getProductDetails())
        .then((data) => {
          setProductDetails({ ...data });
          setProductsList([...data.products]);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  function EditQuoteRequest() {
    let productId = 0;
    let productVariationId = 0;
    let pricingStructureId = 0;
    let quoteId = "";
    let allInPrice = null;
    let components = [];
    setFormHeading(Constant.FORM_HEADING);
    setQuoteLoader(true);
    if (state?.quoteId !== null) {
      dispatch(getQuoteDetails(state.quoteId))
        .then((data) => {
          crmData = { ...crmData, ...data.opportunityDetails };

          crmData.isBroker = crmData.isBroker ? "Yes" : "No";
          crmData.commissionPercentage = parseFloat(
            data.quoteDetails.commission,
          );
          setOpportunityType(data.quoteDetails.oppurtunityType);
          setCommissionPercentageValue(
            parseFloat(data.quoteDetails.commission),
          );
          setcountryUtilizationVariation(
            data?.quoteDetails?.blendedUtilization,
          );
          setIsUtilizationChanged(data?.quoteDetails?.isUtilizationUpdated);
          sessionStorage.removeItem(LocalStorageKeys.CRMDATAINITIAL);
          const jsonCRMData = JSON.stringify(data.opportunityDetails);
          sessionStorage.setItem(LocalStorageKeys.CRMDATAINITIAL, jsonCRMData);

          //storing CRM data to reducer
          dispatch({
            type: UPDATE_CRM_DATA,
            payload: data.opportunityDetails,
          });

          allInPrice = data.allInPrice;

          productId = data.quoteDetails.productId;

          if (data?.quoteDetails?.rfpFileName) {
            let splitedfilename = data.quoteDetails?.rfpFileName.split("_");
            if (splitedfilename.length > 0) splitedfilename.shift();
            setSelectedFile(splitedfilename.join("_"));
          }
          productVariationId = data.quoteDetails.productVariationId;

          let countryHeadcount = data.countryHeadCounts.map((item) => {
            return {
              countryName: item.countryName,
              headCount: item.headcount,
            };
          });
          setCountryHeadCountList(countryHeadcount);
          quoteId = data.quoteDetails.quoteId;
          pricingStructureId = data.quoteDetails.pricingStructureId;

          if (productId > 1) {
            getNonEapData(allInPrice);
          }
          components = [...data.components];
          components.map((component) => {
            component.checked = true;
          });

          data.quoteDetails.discount > 0
            ? setIsDiscountApplied(true)
            : setIsDiscountApplied(false);
          setExistingDiscountValue(data.quoteDetails.discount);

          setPricingStructureLbl(
            data.quoteDetails.pricingStructureName +
              ` ${crmData.currencyCode === "USD" ? "" : crmData.currencyCode}`,
          );

          setPricingStructureUSDLbl(
            data.quoteDetails.pricingStructureName + " USD",
          );

          const headCount = data?.countryHeadCounts?.reduce(
            (accumulator, object) => {
              return accumulator + object.headcount;
            },
            0,
          );
          setSumHeadCounts(headCount?.toLocaleString());

          const formattedDeadlineDate = moment(
            data.quoteDetails.deadline,
          ).format("YYYY-MM-DD");
          setFormValues({ ...data.quoteDetails });

          setFormValues((prevFormValues) => ({
            ...prevFormValues,
            deadline: formattedDeadlineDate,
            numberOfYears: parseInt(data?.quoteDetails?.numberOfYears),
          }));

          if (
            Object.values(CalculatedProducts).includes(
              data?.quoteDetails?.productId,
            )
          ) {
            sumAndSetAmHoursValue(allInPrice);
          } else {
            setFormValues((prevFormValues) => ({
              ...prevFormValues,
              amHours: data?.quoteDetails?.amHours,
            }));
          }

          if (
            opportunityType === "NEW" &&
            data?.quoteDetails?.quoteStatusId === QuoteStatus.SAVEASDRAFT
          ) {
            setFormValues((prevFormValues) => ({
              ...prevFormValues,
              amHours: 0,
            }));
          }

          if (isEmpty(productDetails)) {
            dispatch(getProductDetails())
              .then((data) => {
                console.log(data, "product details");
                setIsAccordianDisabled(false);
                setIsAccordianExpanded(true);
                setProductDetails({ ...data });
                setProductsList([...data.products]);
                setProductVariationsList([
                  ...data.productVariations.filter(
                    (x) => x.productId === productId,
                  ),
                ]);

                setPricingStructureList([
                  ...data.pricingStructures.filter(
                    (x) => x.productId === productId,
                  ),
                ]);
                setShowVariationAccordian(true);

                if (productVariationId) {
                  const allProductVariationComponents = [
                    ...data.components.filter(
                      (x) =>
                        x.productVariationId === productVariationId &&
                        x.productId === productId,
                    ),
                  ];

                  const selectedComponents = [...components];

                  allProductVariationComponents.map((component) => {
                    selectedComponents.map((selectedComp) => {
                      if (selectedComp.id === component.id) {
                        component.checked = true;
                      }
                    });
                  });
                  console.log(
                    "selected Components PV",
                    allProductVariationComponents,
                  );
                  allProductVariationComponents.map((prodComp) => {
                    prodComp.disabled =
                      prodComp.autoSelect && !prodComp.optional;
                  });
                  setComponentList(allProductVariationComponents);
                  if (
                    productId ===
                    AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS
                  ) {
                    const BOHselectedComponents =
                      allProductVariationComponents.filter(
                        (comp) => comp.checked === true,
                      );

                    let BOHMappingMasterArray =
                      BankOfHoursComponentMappingMasterArray;
                    let BOHPricingStructureMappingArray =
                      BOHComponentPricingStructureMap;

                    var componentPricingHash = Object.create(null);

                    var result = BOHMappingMasterArray.map(
                      (
                        (hash) => (a) =>
                          (hash[a.id] = {
                            id: a.id,
                            name: a.name,
                            pricingStructures: [],
                          })
                      )(componentPricingHash),
                    );

                    BOHPricingStructureMappingArray.forEach(
                      (
                        (hash) => (a) =>
                          hash[a.fkey].pricingStructures.push(a.id)
                      )(componentPricingHash),
                    );

                    if (BOHselectedComponents.length <= 0) {
                      setPricingStructureList([
                        ...data.pricingStructures.filter(
                          (x) => x.productId === formValues.productId,
                        ),
                      ]);
                    }

                    BOHselectedComponents.forEach((currentComponent) => {
                      const currentComponentId = currentComponent?.id;

                      const mappedPricingStructures = result.filter(
                        (item) => item.id === currentComponentId,
                      )[0]?.pricingStructures;

                      let componentPricingStructuresFiltered = [
                        ...data.pricingStructures.filter(function (e) {
                          return (
                            mappedPricingStructures.indexOf(e.id) != -1 &&
                            e.productId === productId
                          );
                        }),
                      ];

                      if (
                        currentComponentId ===
                          BankOfHoursComponentsEnum.CONSULTING ||
                        currentComponentId ===
                          BankOfHoursComponentsEnum.ITDEVELOPMENT
                      ) {
                        setPricingStructureList([
                          ...data.pricingStructures.filter(
                            (x) => x.productId === productId,
                          ),
                        ]);
                      } else {
                        setPricingStructureList(
                          componentPricingStructuresFiltered,
                        );
                      }
                    });
                  }
                } else {
                  const allProductVariationComponents = [
                    ...data.productComponents.filter(
                      (x) => x.productId === productId,
                    ),
                  ];

                  const selectedComponents = [...components];

                  allProductVariationComponents.map((component) => {
                    component.checked = false;
                    selectedComponents.map((selectedComp) => {
                      if (selectedComp.id === component.id) {
                        component.checked = true;
                      }
                    });
                  });
                  allProductVariationComponents.map((prodComp) => {
                    prodComp.disabled =
                      prodComp.autoSelect && !prodComp.optional;
                  });
                  setComponentList(allProductVariationComponents);
                  if (
                    productId ===
                    AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS
                  ) {
                    const BOHselectedComponents =
                      allProductVariationComponents.filter(
                        (comp) => comp.checked === true,
                      );

                    let BOHMappingMasterArray =
                      BankOfHoursComponentMappingMasterArray;
                    let BOHPricingStructureMappingArray =
                      BOHComponentPricingStructureMap;

                    var componentPricingHash = Object.create(null);

                    var result = BOHMappingMasterArray.map(
                      (
                        (hash) => (a) =>
                          (hash[a.id] = {
                            id: a.id,
                            name: a.name,
                            pricingStructures: [],
                          })
                      )(componentPricingHash),
                    );

                    BOHPricingStructureMappingArray.forEach(
                      (
                        (hash) => (a) =>
                          hash[a.fkey].pricingStructures.push(a.id)
                      )(componentPricingHash),
                    );

                    if (BOHselectedComponents.length <= 0) {
                      setPricingStructureList([
                        ...data.pricingStructures.filter(
                          (x) => x.productId === formValues.productId,
                        ),
                      ]);
                    }

                    BOHselectedComponents.forEach((currentComponent) => {
                      const currentComponentId = currentComponent?.id;

                      const mappedPricingStructures = result.filter(
                        (item) => item.id === currentComponentId,
                      )[0]?.pricingStructures;

                      let componentPricingStructuresFiltered = [
                        ...data.pricingStructures.filter(function (e) {
                          return (
                            mappedPricingStructures.indexOf(e.id) != -1 &&
                            e.productId === productId
                          );
                        }),
                      ];

                      if (
                        currentComponentId ===
                          BankOfHoursComponentsEnum.CONSULTING ||
                        currentComponentId ===
                          BankOfHoursComponentsEnum.ITDEVELOPMENT
                      ) {
                        setPricingStructureList([
                          ...data.pricingStructures.filter(
                            (x) => x.productId === productId,
                          ),
                        ]);
                      } else {
                        setPricingStructureList(
                          componentPricingStructuresFiltered,
                        );
                      }
                    });
                  }
                  console.log(
                    "selected Components PRODUCT",
                    allProductVariationComponents,
                  );
                }
                //Calculated products & BOH/Pathways/GWQ/NPRTW specific
                hideAndShowVariationFields(productId);

                getUtilizationDistribution(
                  productId,
                  productVariationId,
                  quoteId,
                );
                bindAllInPrice(allInPrice, pricingStructureId);
                setLoadingState(false);
              })
              .catch((e) => {
                console.log(e);
                setLoadingState(false);
              });
          }
          setQuoteLoader(false);
        })
        .catch((e) => {
          console.log(e);
          setQuoteLoader(false);
          setLoadingState(false);
        });
    }
  }
  console.log(countryHeadCountList, "countryHeadCountList");

  function sumAndSetAmHoursValue(allInPrice) {
    let countryAmHours = [];

    allInPrice.map((item) => {
      if (countryAmHours.length > 0) {
        const index = countryAmHours.find(
          (x) => x.countryId === item.countryId,
        );
        if (!index) {
          countryAmHours.push({
            countryId: item.countryId,
            amHours: item.amHoursIncluded,
          });
        }
      } else {
        countryAmHours.push({
          countryId: item.countryId,
          amHours: item.amHoursIncluded,
        });
      }
    });

    let sumAmHours = 0;

    countryAmHours.map((item) => {
      sumAmHours += item.amHours;
    });

    sumAmHours = Math.round(sumAmHours);

    setFieldIsVisible((previousValues) => ({
      ...previousValues,
      AMHOURS: true,
    }));

    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      amHours: sumAmHours,
    }));
  }

  function getNonEapData(allinPrice) {
    if (allinPrice.length > 0) {
      setNonEapRows([]);

      setNonEapRows((prevArray) => [...prevArray, allinPrice[0]]);
      setNonEapData(allinPrice[0]);
    }
  }

  function DuplicateQuoteWithPopulation() {
    let quoteid = "";
    if (state?.quoteId !== null) {
      dispatch(getDuplicateQuoteDetails(state.quoteId, loggedUser?.user?.id))
        .then((data) => {
          let allInPrice = data.allInPrice;
          let productId = data.quoteDetails.productId;
          let productVariationId = data.quoteDetails.productVariationId;
          let pricingStructureId = data.quoteDetails.pricingStructureId;

          quoteid = data?.quoteDetails?.quoteId;
          let quoteId = quoteid;

          let oldquote = data;
          setSelectedFile(data.quoteDetails?.rfpFileName);
          if (data?.quoteDetails?.rfpFileName) {
            let splitedfilename = data.quoteDetails?.rfpFileName.split("_");
            if (splitedfilename.length > 0) splitedfilename.shift();
            setSelectedFile(splitedfilename.join("_"));
          }
          //setExistingComponentList(data.components);
          let isBOHNonEAP = false;
          let components = [...data.components];
          components.map((component) => {
            component.checked = component.autoSelect;
            component.disabled = !component.optional;
          });

          if (
            !Object.values(CalculatedProducts).includes(productId) ||
            isBOHNonEAP
          ) {
            setPricingStructureVal("");
            getNonEapData(allInPrice);
            const obj = {
              discount: data?.quoteDetails?.discount,
              quoteId: quoteId,
              commissionPercent: data?.quoteDetails?.commission,
              revenueStage1ReqCurrency: allInPrice[0]?.revenueStage1ReqCurrency,
              revenueStage1USD: allInPrice[0]?.revenueStage1USD,
              revenueStage2ReqCurrency: allInPrice[0]?.revenueStage2ReqCurrency,
              revenueStage2USD: allInPrice[0]?.revenueStage2USD,
              ffsAnnualUSD: allInPrice[0]?.ffsAnnualUSD,
              ffsReqCurrency: allInPrice[0]?.ffsReqCurrency,
              numberOfYears: parseInt(oldquote?.quoteDetails?.numberOfYears),
            };
            dispatch(SaveQuoteCalculationsNonEAP(obj))
              .then((data) => {
                if (data) {
                  console.log("non eap", data);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }

          setPricingStructureLbl(
            data.quoteDetails.pricingStructureName +
              ` ${crmData.currencyCode === "USD" ? "" : crmData.currencyCode}`,
          );
          setPricingStructureUSDLbl(
            data.quoteDetails.pricingStructureName + " USD",
          );

          const formattedDeadlineDate = moment(
            data.quoteDetails.deadline,
          ).format("YYYY-MM-DD");
          setFormValues({ ...data.quoteDetails });

          setFormValues((prevFormValues) => ({
            ...prevFormValues,
            deadline: formattedDeadlineDate,
            quoteStatusId: QuoteStatus.SAVEASDRAFT,
            quoteId: quoteid,
          }));

          if (isEmpty(productDetails)) {
            dispatch(getProductDetails())
              .then((data) => {
                console.log(data, "product details");
                setIsAccordianDisabled(false);
                setIsAccordianExpanded(true);
                setProductDetails({ ...data });
                setProductsList([...data.products]);
                setProductVariationsList([
                  ...data.productVariations.filter(
                    (x) => x.productId === productId,
                  ),
                ]);
                setPricingStructureList([
                  ...data.pricingStructures.filter(
                    (x) => x.productId === productId,
                  ),
                ]);
                setShowVariationAccordian(true);

                if (productVariationId) {
                  const allProductVariationComponents = [
                    ...data.components.filter(
                      (x) => x.productVariationId === productVariationId,
                    ),
                  ];

                  const selectedComponents = [...components];

                  allProductVariationComponents.map((component) => {
                    selectedComponents.map((selectedComp) => {
                      if (selectedComp.id === component.id) {
                        component.checked = true;
                      }
                    });
                  });
                  console.log(
                    "selected Components PV",
                    allProductVariationComponents,
                  );
                  allProductVariationComponents.map((prodComp) => {
                    prodComp.disabled =
                      prodComp.autoSelect && !prodComp.optional;
                  });
                  setComponentList(allProductVariationComponents);
                } else {
                  const allProductVariationComponents = [
                    ...data.productComponents.filter(
                      (x) => x.productId === productId,
                    ),
                  ];

                  const selectedComponents = [...components];

                  allProductVariationComponents.map((component) => {
                    component.checked = false;
                    selectedComponents.map((selectedComp) => {
                      if (selectedComp.id === component.id) {
                        component.checked = true;
                      }
                    });
                  });

                  allProductVariationComponents.map((prodComp) => {
                    prodComp.disabled =
                      prodComp.autoSelect && !prodComp.optional;
                  });
                  setComponentList(allProductVariationComponents);
                  console.log(
                    "selected Components PRODUCT",
                    allProductVariationComponents,
                  );
                }
                //Calculated products & BOH specific
                hideAndShowVariationFields(productId);

                getUtilizationDistribution(
                  productId,
                  productVariationId,
                  quoteId,
                );
                const obJCalculate = {
                  opportunityId: oldquote.opportunityDetails.oppurtunityId,
                  quoteId: quoteId,
                  userId: loggedUser.user.id,
                  numberOfSessionModels: formValues.sessions
                    ? parseFloat(formValues.sessions)
                    : 0,
                  utilization: formValues.utilization
                    ? parseFloat(formValues.utilization)
                    : 0,
                  productId: productId,
                  productVariationId: productVariationId,
                  requestedCurrencyId: oldquote.quoteDetails.currencyId,
                  commission:
                    crmData.commissionPercentage &&
                    crmData.commissionPercentage !== ""
                      ? parseFloat(crmData.commissionPercentage)
                      : formValues.commission && formValues.commission !== ""
                        ? parseFloat(formValues.commission)
                        : 0,
                  discount: parseFloat(
                    oldquote.quoteDetails.discount === ""
                      ? 0
                      : oldquote.quoteDetails.discount,
                  ),
                  oppurtunityType: !optype?.cpqOpportunityType
                    ? opportunityType
                    : optype?.cpqOpportunityType,
                  amHoursUI: oldquote.quoteDetails.amHours,
                  productHours: oldquote.quoteDetails.hours,
                  //companyId: Congiguration.CompanyId,
                  seatCount: oldquote.quoteDetails.seatCount,
                  numberOfYears: parseInt(oldquote.quoteDetails.numberOfYears),
                };
                dispatch(getAllInPrice(obJCalculate))
                  .then((data) => {
                    if (data[0]) {
                      if (
                        data[0].revenueStage4TotalReqCurrency <
                        data[0].floorMargin
                      ) {
                        //setNotificationMessage("Revenue stage 4 is less than Floor margin! Please check calculation input values.");
                        //setNotificationSeverity(Severity.WARNING);
                        //setShowNotification(true);
                        setCalculateBtnLoading(false);
                        setAllInPriceLoading(false);
                        setLoadingState(false);
                        //return false;
                      }
                    }
                    console.log("calc", data);

                    bindAllInPrice(data, pricingStructureId);
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            getUtilizationDistribution(productId, productVariationId, quoteId);

            const obJCalculate = {
              opportunityId: oldquote.opportunityDetails.oppurtunityId,
              quoteId: quoteId,
              userId: loggedUser.user.id,
              numberOfSessionModels: parseFloat(oldquote.quoteDetails.sessions),
              utilization: parseFloat(oldquote.quoteDetails.utilization),
              productId: productId,
              productVariationId: productVariationId,
              requestedCurrencyId: oldquote.quoteDetails.currencyId,
              commission:
                crmData.commissionPercentage &&
                crmData.commissionPercentage !== ""
                  ? parseFloat(crmData.commissionPercentage)
                  : formValues.commission && formValues.commission !== ""
                    ? parseFloat(formValues.commission)
                    : 0,
              discount: parseFloat(
                oldquote.quoteDetails.discount === ""
                  ? 0
                  : oldquote.quoteDetails.discount,
              ),
              oppurtunityType: !optype?.cpqOpportunityType
                ? opportunityType
                : optype?.cpqOpportunityType,
              amHoursUI: oldquote.quoteDetails.amHours,
              productHours: oldquote.quoteDetails.hours,
              //companyId: Congiguration.CompanyId,
              seatCount: oldquote.quoteDetails.seatCount,
              numberOfYears: parseInt(oldquote.quoteDetails.numberOfYears),
            };
            dispatch(getAllInPrice(obJCalculate))
              .then((data) => {
                if (data[0]) {
                  if (
                    data[0].revenueStage4TotalReqCurrency < data[0].floorMargin
                  ) {
                    //setNotificationMessage("Revenue stage 4 is less than Floor margin! Please check calculation input values.");
                    //setNotificationSeverity(Severity.WARNING);
                    //setShowNotification(true);
                    setCalculateBtnLoading(false);
                    setAllInPriceLoading(false);
                    setLoadingState(false);
                    //return false;
                  }
                }
                console.log("calc", data);
                bindAllInPrice(data, formValues.pricingStructureId);
              })
              .catch((e) => {
                console.log(e);
              });

            setLoadingState(false);
          }

          setLoadingState(false);
        })
        .catch((e) => {
          setLoadingState(false);
          console.log(e);
        });
    }
  }

  function UploadPopulationDataToCrm(cpqCountryHCRequestModell) {
    dispatch(addCountryHeadcount(cpqCountryHCRequestModell))
      .then((data) => {
        console.log("Population Sync CRM", data);
        if (data && data !== null) {
          setNotificationMessage("Country Headcount details synced to CRM");
          setNotificationSeverity(Severity.SUCCESS);
          setShowNotification(true);
        }
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
  }

  function GetAndUploadPopulationDataToCrm(quoteId) {
    dispatch(getCrmPopulationUploadData(quoteId))
      .then((data) => {
        if (data && data !== null) {
          //prepare population object
          const countryHeadcount = data.map((obj) => {
            return {
              //id: obj.id,
              countryId: obj.crmCountryId,
              country: obj.countryName,
              headCount: obj.headcount,
              region: obj.region,
            };
          });

          const populationObject = {
            opportunitId: data[0]?.oppurtunityId,
            populations: [...countryHeadcount],
          };

          UploadPopulationDataToCrm(populationObject);
        }
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
  }

  function UploadCountries(countryHeadCount) {
    let Id = null;
    dispatch(saveCountryHeadCount(countryHeadCount))
      .then((data) => {
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          quoteId: data,
        }));
        let quoteid = data;
        Id = data;
        if (crmData.populationDetails === null) {
          GetAndUploadPopulationDataToCrm(quoteid);
          setNotificationMessage("Country Headcount uploaded successfully");
          setNotificationSeverity(Severity.SUCCESS);
          setShowNotification(true);
          setShowButtons(true);
          setLoadingState(false);
        }

        const headCount = countryHeadCount.countryHeadCountType.reduce(
          (accumulator, object) => {
            return accumulator + object.headCount;
          },
          0,
        );

        setCountryHeadCountList(countryHeadCount.countryHeadCountType);
        if (formValues.productId > 0 && formValues.productVariationId > 0) {
          getUtilizationDistribution(
            formValues.productId,
            formValues.productVariationId,
            quoteid,
          );
        }
        setSumHeadCounts(headCount?.toLocaleString());
        if (state?.requestType === "Duplicate") {
          DuplicateQuote(quoteid);
          setLoadingState(false);
        }
        setLoadingState(false);
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
    return Id;
  }

  function DuplicateQuote(quoteid) {
    if (state?.quoteId !== null) {
      dispatch(getDuplicateQuoteDetails(state.quoteId, loggedUser?.user?.id))
        .then((data) => {
          let allInPrice = data.allInPrice;
          let productId = data.quoteDetails.productId;
          let productVariationId = data.quoteDetails.productVariationId;
          let pricingStructureId = data.quoteDetails.pricingStructureId;
          let quoteId = quoteid;
          let oldquote = data;
          setSelectedFile(data.quoteDetails?.rfpFileName);
          if (data?.quoteDetails?.rfpFileName) {
            let splitedfilename = data.quoteDetails?.rfpFileName.split("_");
            if (splitedfilename.length > 0) splitedfilename.shift();
            setSelectedFile(splitedfilename.join("_"));
          }
          //setExistingComponentList(data.components);
          let isBOHNonEAP = false;
          let components = [...data.components];
          components.map((component) => {
            component.checked = component.autoSelect;
            component.disabled = !component.optional;
          });

          if (
            !Object.values(CalculatedProducts).includes(productId) ||
            isBOHNonEAP
          ) {
            setPricingStructureVal("");
            getNonEapData(allInPrice);
            const obj = {
              discount: data?.quoteDetails?.discount,
              quoteId: quoteId,
              commissionPercent: data?.quoteDetails?.commission,
              revenueStage1ReqCurrency: allInPrice[0]?.revenueStage1ReqCurrency,
              revenueStage1USD: allInPrice[0]?.revenueStage1USD,
              revenueStage2ReqCurrency: allInPrice[0]?.revenueStage2ReqCurrency,
              revenueStage2USD: allInPrice[0]?.revenueStage2USD,
              ffsAnnualUSD: allInPrice[0]?.ffsAnnualUSD,
              ffsReqCurrency: allInPrice[0]?.ffsReqCurrency,
              userId: loggedUser?.user?.id,
              numberOfYears: parseInt(oldquote?.quoteDetails?.numberOfYears),
            };
            dispatch(SaveQuoteCalculationsNonEAP(obj))
              .then((data) => {
                if (data) {
                  console.log("non eap", data);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }

          setPricingStructureLbl(
            data.quoteDetails.pricingStructureName +
              ` ${crmData.currencyCode === "USD" ? "" : crmData.currencyCode}`,
          );
          setPricingStructureUSDLbl(
            data.quoteDetails.pricingStructureName + " USD",
          );

          const formattedDeadlineDate = moment(
            data.quoteDetails.deadline,
          ).format("YYYY-MM-DD");
          setFormValues({ ...data.quoteDetails });

          setFormValues((prevFormValues) => ({
            ...prevFormValues,
            deadline: formattedDeadlineDate,
            quoteStatusId: QuoteStatus.SAVEASDRAFT,
            quoteId: quoteid,
          }));

          if (isEmpty(productDetails)) {
            dispatch(getProductDetails())
              .then((data) => {
                console.log(data, "product details");

                setIsAccordianDisabled(false);
                setIsAccordianExpanded(true);
                setProductDetails({ ...data });
                setProductsList([...data.products]);
                setProductVariationsList([
                  ...data.productVariations.filter(
                    (x) => x.productId === productId,
                  ),
                ]);
                setPricingStructureList([
                  ...data.pricingStructures.filter(
                    (x) => x.productId === productId,
                  ),
                ]);
                setShowVariationAccordian(true);
                //setCurrentProductForWLTS(productId);
                if (productVariationId) {
                  const allProductVariationComponents = [
                    ...data.components.filter(
                      (x) =>
                        x.productVariationId === productVariationId &&
                        x.productId === productId,
                    ),
                  ];

                  const selectedComponents = [...components];

                  allProductVariationComponents.map((component) => {
                    selectedComponents.map((selectedComp) => {
                      if (selectedComp.id === component.id) {
                        component.checked = true;
                      }
                    });
                  });
                  console.log(
                    "selected Components PV",
                    allProductVariationComponents,
                  );
                  allProductVariationComponents.map((prodComp) => {
                    prodComp.disabled =
                      prodComp.autoSelect && !prodComp.optional;
                  });
                  setComponentList(allProductVariationComponents);
                  if (
                    productId ===
                    AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS
                  ) {
                    const BOHselectedComponents =
                      allProductVariationComponents.filter(
                        (comp) => comp.checked === true,
                      );

                    let BOHMappingMasterArray =
                      BankOfHoursComponentMappingMasterArray;
                    let BOHPricingStructureMappingArray =
                      BOHComponentPricingStructureMap;

                    var componentPricingHash = Object.create(null);

                    var result = BOHMappingMasterArray.map(
                      (
                        (hash) => (a) =>
                          (hash[a.id] = {
                            id: a.id,
                            name: a.name,
                            pricingStructures: [],
                          })
                      )(componentPricingHash),
                    );

                    BOHPricingStructureMappingArray.forEach(
                      (
                        (hash) => (a) =>
                          hash[a.fkey].pricingStructures.push(a.id)
                      )(componentPricingHash),
                    );

                    if (BOHselectedComponents.length <= 0) {
                      setPricingStructureList([
                        ...data.pricingStructures.filter(
                          (x) => x.productId === formValues.productId,
                        ),
                      ]);
                    }

                    BOHselectedComponents.forEach((currentComponent) => {
                      const currentComponentId = currentComponent?.id;

                      const mappedPricingStructures = result.filter(
                        (item) => item.id === currentComponentId,
                      )[0]?.pricingStructures;

                      let componentPricingStructuresFiltered = [
                        ...data.pricingStructures.filter(function (e) {
                          return (
                            mappedPricingStructures.indexOf(e.id) != -1 &&
                            e.productId === productId
                          );
                        }),
                      ];

                      if (
                        currentComponentId ===
                          BankOfHoursComponentsEnum.CONSULTING ||
                        currentComponentId ===
                          BankOfHoursComponentsEnum.ITDEVELOPMENT
                      ) {
                        setPricingStructureList([
                          ...data.pricingStructures.filter(
                            (x) => x.productId === productId,
                          ),
                        ]);
                      } else {
                        setPricingStructureList(
                          componentPricingStructuresFiltered,
                        );
                      }
                    });
                  }
                } else {
                  const allProductVariationComponents = [
                    ...data.productComponents.filter(
                      (x) => x.productId === productId,
                    ),
                  ];

                  const selectedComponents = [...components];

                  allProductVariationComponents.map((component) => {
                    component.checked = false;
                    selectedComponents.map((selectedComp) => {
                      if (selectedComp.id === component.id) {
                        component.checked = true;
                      }
                    });
                  });

                  allProductVariationComponents.map((prodComp) => {
                    prodComp.disabled =
                      prodComp.autoSelect && !prodComp.optional;
                  });
                  setComponentList(allProductVariationComponents);
                  if (
                    productId ===
                    AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS
                  ) {
                    const BOHselectedComponents =
                      allProductVariationComponents.filter(
                        (comp) => comp.checked === true,
                      );

                    let BOHMappingMasterArray =
                      BankOfHoursComponentMappingMasterArray;
                    let BOHPricingStructureMappingArray =
                      BOHComponentPricingStructureMap;

                    var componentPricingHash = Object.create(null);

                    var result = BOHMappingMasterArray.map(
                      (
                        (hash) => (a) =>
                          (hash[a.id] = {
                            id: a.id,
                            name: a.name,
                            pricingStructures: [],
                          })
                      )(componentPricingHash),
                    );

                    BOHPricingStructureMappingArray.forEach(
                      (
                        (hash) => (a) =>
                          hash[a.fkey].pricingStructures.push(a.id)
                      )(componentPricingHash),
                    );

                    if (BOHselectedComponents.length <= 0) {
                      setPricingStructureList([
                        ...data.pricingStructures.filter(
                          (x) => x.productId === formValues.productId,
                        ),
                      ]);
                    }

                    BOHselectedComponents.forEach((currentComponent) => {
                      const currentComponentId = currentComponent?.id;

                      const mappedPricingStructures = result.filter(
                        (item) => item.id === currentComponentId,
                      )[0]?.pricingStructures;

                      let componentPricingStructuresFiltered = [
                        ...data.pricingStructures.filter(function (e) {
                          return (
                            mappedPricingStructures.indexOf(e.id) != -1 &&
                            e.productId === productId
                          );
                        }),
                      ];

                      if (
                        currentComponentId ===
                          BankOfHoursComponentsEnum.CONSULTING ||
                        currentComponentId ===
                          BankOfHoursComponentsEnum.ITDEVELOPMENT
                      ) {
                        setPricingStructureList([
                          ...data.pricingStructures.filter(
                            (x) => x.productId === productId,
                          ),
                        ]);
                      } else {
                        setPricingStructureList(
                          componentPricingStructuresFiltered,
                        );
                      }
                    });
                  }
                  console.log(
                    "selected Components PRODUCT",
                    allProductVariationComponents,
                  );
                }
                //Calculated products & BOH specific
                hideAndShowVariationFields(productId);

                getUtilizationDistribution(
                  productId,
                  productVariationId,
                  quoteId,
                );
                const obJCalculate = {
                  opportunityId: oldquote.opportunityDetails.oppurtunityId,
                  quoteId: quoteId,
                  userId: loggedUser.user.id,
                  numberOfSessionModels: formValues.sessions
                    ? parseFloat(formValues.sessions)
                    : 0,
                  utilization: formValues.utilization
                    ? parseFloat(formValues.utilization)
                    : 0,
                  productId: productId,
                  productVariationId: productVariationId,
                  requestedCurrencyId: oldquote.quoteDetails.currencyId,
                  commission:
                    crmData.commissionPercentage &&
                    crmData.commissionPercentage !== ""
                      ? parseFloat(crmData.commissionPercentage)
                      : formValues.commission && formValues.commission !== ""
                        ? parseFloat(formValues.commission)
                        : 0,
                  discount: parseFloat(
                    oldquote.quoteDetails.discount === ""
                      ? 0
                      : oldquote.quoteDetails.discount,
                  ),
                  oppurtunityType: !optype?.cpqOpportunityType
                    ? opportunityType
                    : optype?.cpqOpportunityType,
                  amHoursUI: oldquote.quoteDetails.amHours,
                  productHours: oldquote.quoteDetails.hours,
                  //companyId: Congiguration.CompanyId,
                  seatCount: oldquote.quoteDetails.seatCount,
                  numberOfYears: parseInt(
                    oldquote?.quoteDetails?.numberOfYears,
                  ),
                };
                dispatch(getAllInPrice(obJCalculate))
                  .then((data) => {
                    if (data[0]) {
                      if (
                        data[0].revenueStage4TotalReqCurrency <
                        data[0].floorMargin
                      ) {
                        //setNotificationMessage("Revenue stage 4 is less than Floor margin! Please check calculation input values.");
                        //setNotificationSeverity(Severity.WARNING);
                        //setShowNotification(true);
                        setCalculateBtnLoading(false);
                        setAllInPriceLoading(false);
                        setLoadingState(false);
                        //return false;
                      }
                    }
                    console.log("calc", data);

                    bindAllInPrice(data, pricingStructureId);
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            getUtilizationDistribution(productId, productVariationId, quoteId);

            const obJCalculate = {
              opportunityId: oldquote.opportunityDetails.oppurtunityId,
              quoteId: quoteId,
              userId: loggedUser.user.id,
              numberOfSessionModels: parseFloat(oldquote.quoteDetails.sessions),
              utilization: parseFloat(oldquote.quoteDetails.utilization),
              productId: productId,
              productVariationId: productVariationId,
              requestedCurrencyId: oldquote.quoteDetails.currencyId,
              commission:
                crmData.commissionPercentage &&
                crmData.commissionPercentage !== ""
                  ? parseFloat(crmData.commissionPercentage)
                  : formValues.commission && formValues.commission !== ""
                    ? parseFloat(formValues.commission)
                    : 0,
              discount: parseFloat(
                oldquote.quoteDetails.discount === ""
                  ? 0
                  : oldquote.quoteDetails.discount,
              ),
              oppurtunityType: !optype?.cpqOpportunityType
                ? opportunityType
                : optype?.cpqOpportunityType,
              amHoursUI: oldquote.quoteDetails.amHours,
              productHours: oldquote.quoteDetails.hours,
              //companyId: Congiguration.CompanyId,
              seatCount: oldquote.quoteDetails.seatCount,
              numberOfYears: parseInt(oldquote?.quoteDetails?.numberOfYears),
            };
            dispatch(getAllInPrice(obJCalculate))
              .then((data) => {
                if (data[0]) {
                  if (
                    data[0].revenueStage4TotalReqCurrency < data[0].floorMargin
                  ) {
                    //setNotificationMessage("Revenue stage 4 is less than Floor margin! Please check calculation input values.");
                    //setNotificationSeverity(Severity.WARNING);
                    //setShowNotification(true);
                    setCalculateBtnLoading(false);
                    setAllInPriceLoading(false);
                    setLoadingState(false);
                    //return false;
                  }
                }
                console.log("calc", data);
                bindAllInPrice(data, formValues.pricingStructureId);
              })
              .catch((e) => {
                console.log(e);
              });

            setLoadingState(false);
          }

          setLoadingState(false);
        })
        .catch((e) => {
          setLoadingState(false);
          console.log(e);
        });
    }
  }

  function filterPricingStructureByBOHComponent(currentComponents) {
    const selectedComponents = currentComponents.filter(
      (comp) => comp.checked === true,
    );

    let BOHMappingMasterArray = BankOfHoursComponentMappingMasterArray;
    let BOHPricingStructureMappingArray = BOHComponentPricingStructureMap;

    var componentPricingHash = Object.create(null);

    var result = BOHMappingMasterArray.map(
      (
        (hash) => (a) =>
          (hash[a.id] = { id: a.id, name: a.name, pricingStructures: [] })
      )(componentPricingHash),
    );

    BOHPricingStructureMappingArray.forEach(
      (
        (hash) => (a) =>
          hash[a.fkey].pricingStructures.push(a.id)
      )(componentPricingHash),
    );

    if (selectedComponents.length <= 0) {
      setPricingStructureList([
        ...productDetails.pricingStructures.filter(
          (x) => x.productId === formValues.productId,
        ),
      ]);
    }

    selectedComponents.forEach((currentComponent) => {
      const currentComponentId = currentComponent?.id;

      const mappedPricingStructures = result.filter(
        (item) => item.id === currentComponentId,
      )[0]?.pricingStructures;

      let componentPricingStructuresFiltered = [];

      if (mappedPricingStructures) {
        componentPricingStructuresFiltered = [
          ...productDetails.pricingStructures.filter(function (e) {
            return (
              mappedPricingStructures.indexOf(e.id) != -1 &&
              e.productId === formValues.productId
            );
          }),
        ];
      }

      if (
        currentComponentId === BankOfHoursComponentsEnum.CONSULTING ||
        currentComponentId === BankOfHoursComponentsEnum.ITDEVELOPMENT
      ) {
        setPricingStructureList([
          ...productDetails.pricingStructures.filter(
            (x) => x.productId === formValues.productId,
          ),
        ]);
      } else {
        setPricingStructureList(componentPricingStructuresFiltered);
      }
    });
  }

  function hideShowCalculateBtnAndNonEAPGridBOH(currentComponents) {
    const selectedComponents = currentComponents.filter(
      (comp) => comp.checked === true,
    );
    if (selectedComponents.length <= 0) {
      setIsConsultingITDevShowNonEAPGrid(false);
      setIsConsultingITDevShowCalculate(true);
    }
  }
  //Handle component select/de-select
  const handleInputChanges = (event, id, value) => {
    const currentComponentId = parseInt(event.target.name);

    const currentComponents = [...componentList];

    if (
      formValues.productId > 0 &&
      formValues.productId === ProductsEnum.BANKOFHOURSSESSIONS
    ) {
      const disableForCounselingITDev = [
        BankOfHoursComponentsEnum.RAPIDRESPONSECRITICALINCIDENT,
        BankOfHoursComponentsEnum.TRAINING,
        BankOfHoursComponentsEnum.ORIENTATION,
        BankOfHoursComponentsEnum.COUNSELING,
        BankOfHoursComponentsEnum.ITDEVELOPMENT,
        BankOfHoursComponentsEnum.CONSULTING,
      ];

      const disableForRRCITrainingOrientation = [
        BankOfHoursComponentsEnum.COUNSELING,
        BankOfHoursComponentsEnum.ITDEVELOPMENT,
        BankOfHoursComponentsEnum.CONSULTING,
      ];

      //uncheck
      if (!id) {
        currentComponents.map((component) => {
          if (component.id === currentComponentId) {
            component.checked = false;
          }
        });

        filterPricingStructureByBOHComponent(currentComponents);
        hideShowCalculateBtnAndNonEAPGridBOH(currentComponents);
        setComponentList(currentComponents);
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          componentIds: currentComponents
            .filter((comp) => comp.checked)
            .map((comp) => comp.id + ",")
            .toString()
            .slice(0, -1),
        }));
      }
      //check
      else {
        currentComponents.map((component) => {
          if (component.id === currentComponentId) {
            if (
              currentComponentId === BankOfHoursComponentsEnum.COUNSELING ||
              currentComponentId === BankOfHoursComponentsEnum.ITDEVELOPMENT ||
              currentComponentId === BankOfHoursComponentsEnum.CONSULTING
            ) {
              const componentsToDisable = currentComponents.filter(
                (component) => disableForCounselingITDev.includes(component.id),
              );

              let isInvalidComponentChecked = null;
              componentsToDisable.map((component) => {
                if (isInvalidComponentChecked !== null) {
                  isInvalidComponentChecked =
                    isInvalidComponentChecked || component.checked;
                } else {
                  isInvalidComponentChecked = component.checked;
                }
              });

              if (isInvalidComponentChecked) {
                setNotificationMessage("Combination not allowed!");
                setNotificationSeverity(Severity.WARNING);
                setShowNotification(true);
                return;
              } else {
                component.checked = true;
                filterPricingStructureByBOHComponent(currentComponents);
                hideShowCalculateBtnAndNonEAPGridBOH(currentComponents);
              }
              setComponentList(currentComponents);
            } else if (
              currentComponentId ===
                BankOfHoursComponentsEnum.RAPIDRESPONSECRITICALINCIDENT ||
              currentComponentId === BankOfHoursComponentsEnum.TRAINING ||
              currentComponentId === BankOfHoursComponentsEnum.ORIENTATION
            ) {
              const componentsToDisable = currentComponents.filter(
                (component) =>
                  disableForRRCITrainingOrientation.includes(component.id),
              );

              let isInvalidComponentChecked = null;
              componentsToDisable.map((component) => {
                if (isInvalidComponentChecked !== null) {
                  isInvalidComponentChecked =
                    isInvalidComponentChecked || component.checked;
                } else {
                  isInvalidComponentChecked = component.checked;
                }
              });

              if (isInvalidComponentChecked) {
                setNotificationMessage("Combination not allowed!");
                setNotificationSeverity(Severity.WARNING);
                setShowNotification(true);
                return;
              } else {
                component.checked = true;
                filterPricingStructureByBOHComponent(currentComponents);
                hideShowCalculateBtnAndNonEAPGridBOH(currentComponents);
              }
            } else {
              component.checked = true;
              filterPricingStructureByBOHComponent(currentComponents);
              hideShowCalculateBtnAndNonEAPGridBOH(currentComponents);
            }
            setComponentList(currentComponents);
            setFormValues((prevFormValues) => ({
              ...prevFormValues,
              componentIds: currentComponents
                .filter((comp) => comp.checked)
                .map((comp) => comp.id + ",")
                .toString()
                .slice(0, -1),
            }));
          }
        });
      }
    } else {
      if (!id) {
        currentComponents.map((component) => {
          if (component.id === currentComponentId) {
            component.checked = false;
          }
        });
        setComponentList(currentComponents);
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          componentIds: currentComponents
            .filter((comp) => comp.checked)
            .map((comp) => comp.id + ",")
            .toString()
            .slice(0, -1),
        }));
      } else {
        currentComponents.map((component) => {
          if (component.id === currentComponentId) {
            component.checked = true;
          }
        });
        setComponentList(currentComponents);
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          componentIds: currentComponents
            .filter((comp) => comp.checked)
            .map((comp) => comp.id + ",")
            .toString()
            .slice(0, -1),
        }));
      }
    }
  };

  //#region  Non Eap Table function
  const onChange = (event, col, val) => {
    const value = val?.trim();
    if (!isNaN(val)) {
      setNonEapData((prevState) => ({
        ...prevState,
        [col]: value,
      }));
    } else {
      event.target.value = "";
      setNotificationMessage("Invalid data input : Please check input values!");
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
    }
  };

  const handleNonEapEditButtonClick = () => {
    setIsNonEapEditable(true);
  };
  const handleNonEapSaveButtonClick = () => {
    if (Object.keys(nonEapData).length > 0) {
      if (
        nonEapData?.revenueStage1ReqCurrency === undefined ||
        nonEapData?.revenueStage1ReqCurrency === "" ||
        nonEapData?.revenueStage1USD === undefined ||
        nonEapData?.revenueStage1USD === "" ||
        nonEapData?.revenueStage2ReqCurrency === undefined ||
        nonEapData?.revenueStage2ReqCurrency === "" ||
        nonEapData?.revenueStage2USD === undefined ||
        nonEapData?.revenueStage2USD === ""
        //|| nonEapData?.ffsAnnualUSD === undefined //|| nonEapData?.ffsAnnualUSD === "" //These can be null
        //|| nonEapData?.ffsReqCurrency === undefined //|| nonEapData?.ffsReqCurrency === "" //These can be null
      ) {
        setNotificationMessage("Please fill all the input values!");
        setNotificationSeverity(Severity.ERROR);
        setShowNotification(true);
      } else {
        const obj = {
          discount: !isNaN(formValues.discount)
            ? parseFloat(formValues.discount)
            : 0,
          quoteId: formValues.quoteId,
          commissionPercent:
            !isNaN(formValues.commission) || formValues.commission !== ""
              ? parseFloat(formValues.commission)
              : 0,
          revenueStage1ReqCurrency: !isNaN(nonEapData?.revenueStage1ReqCurrency)
            ? parseFloat(nonEapData?.revenueStage1ReqCurrency)
            : 0,
          revenueStage1USD: !isNaN(nonEapData?.revenueStage1USD)
            ? parseFloat(nonEapData?.revenueStage1USD)
            : 0,
          revenueStage2ReqCurrency: !isNaN(nonEapData?.revenueStage2ReqCurrency)
            ? parseFloat(nonEapData?.revenueStage2ReqCurrency)
            : 0,
          revenueStage2USD: !isNaN(nonEapData?.revenueStage2USD)
            ? parseFloat(nonEapData?.revenueStage2USD)
            : 0,
          ffsAnnualUSD: !isNaN(nonEapData?.ffsAnnualUSD)
            ? parseFloat(nonEapData?.ffsAnnualUSD)
            : 0,
          ffsReqCurrency: !isNaN(nonEapData?.ffsReqCurrency)
            ? parseFloat(nonEapData?.ffsReqCurrency)
            : 0,
          userId: loggedUser?.user?.id,
          numberOfYears: parseInt(formValues?.numberOfYears),
        };
        dispatch(SaveQuoteCalculationsNonEAP(obj))
          .then((data) => {
            if (data) {
              setNotificationMessage(
                "Quote Calculation data saved successfully!",
              );
              setNotificationSeverity(Severity.SUCCESS);
              setShowNotification(true);
              setNonEapRows([]);
              setNonEapRows((prevArray) => [...prevArray, data]);
              setIsNonEapEditable(false);
              bindAllInPriceNonEAP(formValues.pricingStructureId, data);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    } else {
      setIsNonEapEditable(false);
      setNotificationMessage("No changes to save");
      setNotificationSeverity(Severity.INFO);
      setShowNotification(true);
    }
  };

  function bindAllInPriceNonEAP(pricingStructureId, data) {
    if (data?.tcvcad !== undefined) {
      setTcvCad(
        `CAD ${Number(data?.tcvcad?.toFixed(2)).toLocaleString("en", {
          useGrouping: true,
          roundingMode: "trunc",
          minimumFractionDigits: 2,
        })}`,
      );
    }
    switch (pricingStructureId) {
      case PricingStructuresEnum.FFS:
        setPricingStructureVal(
          data?.ffsReqCurrency
            ? `${crmData.currencyCode}  ${Number(
                data?.ffsReqCurrency?.toFixed(2),
              ).toLocaleString("en", {
                useGrouping: true,
                roundingMode: "trunc",
                minimumFractionDigits: 2,
              })}`
            : `${crmData.currencyCode} 0`,
        );
        setPricingStructureUSDVal(
          data?.ffsAnnualUSD
            ? `USD ${Number(data?.ffsAnnualUSD?.toFixed(2)).toLocaleString(
                "en",
                {
                  useGrouping: true,
                  roundingMode: "trunc",
                  minimumFractionDigits: 2,
                },
              )}`
            : `USD 0`,
        );
        break;
      case PricingStructuresEnum.FLATFEEQUARTERLY:
        setPricingStructureVal(
          data?.ffsReqCurrency
            ? `${crmData.currencyCode}  ${Number(
                data?.ffsReqCurrency?.toFixed(2),
              ).toLocaleString("en", {
                useGrouping: true,
                roundingMode: "trunc",
                minimumFractionDigits: 2,
              })}`
            : `${crmData.currencyCode} 0`,
        );
        setPricingStructureUSDVal(
          data?.ffsAnnualUSD
            ? `USD ${Number(data?.ffsAnnualUSD?.toFixed(2)).toLocaleString(
                "en",
                {
                  useGrouping: true,
                  roundingMode: "trunc",
                  minimumFractionDigits: 2,
                },
              )}`
            : `USD 0`,
        );
        break;
      case PricingStructuresEnum.FFSPERCASE:
        setPricingStructureVal(
          data?.ffsReqCurrency
            ? `${crmData.currencyCode}  ${Number(
                data?.ffsReqCurrency?.toFixed(2),
              ).toLocaleString("en", {
                useGrouping: true,
                roundingMode: "trunc",
                minimumFractionDigits: 2,
              })}`
            : `${crmData.currencyCode} 0`,
        );
        setPricingStructureUSDVal(
          data?.ffsAnnualUSD
            ? `USD ${Number(data?.ffsAnnualUSD?.toFixed(2)).toLocaleString(
                "en",
                {
                  useGrouping: true,
                  roundingMode: "trunc",
                  minimumFractionDigits: 2,
                },
              )}`
            : `USD 0`,
        );
        break;
      case PricingStructuresEnum.FFSPERSESSION:
        setPricingStructureVal(
          data?.ffsReqCurrency
            ? `${crmData.currencyCode}  ${Number(
                data?.ffsReqCurrency?.toFixed(2),
              ).toLocaleString("en", {
                useGrouping: true,
                roundingMode: "trunc",
                minimumFractionDigits: 2,
              })}`
            : `${crmData.currencyCode} 0`,
        );
        setPricingStructureUSDVal(
          data?.ffsAnnualUSD
            ? `USD ${Number(data?.ffsAnnualUSD?.toFixed(2)).toLocaleString(
                "en",
                {
                  useGrouping: true,
                  roundingMode: "trunc",
                  minimumFractionDigits: 2,
                },
              )}`
            : `USD 0`,
        );
        break;
      case PricingStructuresEnum.FFSPERHOUR:
        setPricingStructureVal(
          data?.ffsReqCurrency
            ? `${crmData.currencyCode}  ${Number(
                data?.ffsReqCurrency?.toFixed(2),
              ).toLocaleString("en", {
                useGrouping: true,
                roundingMode: "trunc",
                minimumFractionDigits: 2,
              })}`
            : `${crmData.currencyCode} 0`,
        );
        setPricingStructureUSDVal(
          data?.ffsAnnualUSD
            ? `USD ${Number(data?.ffsAnnualUSD?.toFixed(2)).toLocaleString(
                "en",
                {
                  useGrouping: true,
                  roundingMode: "trunc",
                  minimumFractionDigits: 2,
                },
              )}`
            : `USD 0`,
        );
        break;
      case PricingStructuresEnum.FLATFEEANNUAL:
        setPricingStructureVal(
          `${crmData.currencyCode}  ${Number(
            data?.flatFeeAnnualReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(data?.flatFeeAnnualUSD?.toFixed(2)).toLocaleString(
            "en",
            {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            },
          )}`,
        );
        break;
      case PricingStructuresEnum.FLATFEEMONTHLY:
        setPricingStructureVal(
          `${crmData.currencyCode}  ${Number(
            data?.flatFeeMonthlyReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(data?.flatFeeMonthlyUSD?.toFixed(2)).toLocaleString(
            "en",
            {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            },
          )}`,
        );
        break;
      case PricingStructuresEnum.PEPM:
        setPricingStructureVal(
          `${crmData.currencyCode}  ${Number(
            data?.pepmReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(data?.pepmusd?.toFixed(2)).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        break;
      case PricingStructuresEnum.PEPY:
        setPricingStructureVal(
          `${crmData.currencyCode}  ${Number(
            data?.pepyReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(data?.pepyusd?.toFixed(2)).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        break;

      default:
        setPricingStructureVal("");
        setPricingStructureUSDVal("");
        break;
    }
  }

  //#endregion Non Eap Table function

  //Handle text change events of textboxes
  const handleChange = (event) => {
    const { name, value } = event.target;
    let numbercounterror = "";
    let numberramerror = "";
    let sessionerror = "";
    let numberOfYearsError = "";
    let utilizationerror = "";
    let discounterror = "";
    let seatcounterror = "";
    let hours = "";
    let amhours = "";
    let additionalNotes = "";
    // Update the form values

    if (name === "totalPotentialHeadCountOutside") {
      numbercounterror = Constant.CORRECT_NUMBER_ERROR;
      if (!isNaN(value)) {
        let newvalue = value.trim() === "" ? "" : parseInt(value?.trim());
        formValues[name] = newvalue;
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          [name]: newvalue,
        }));
        numbercounterror = "";
      }
    } else if (name === "noOfRAMs") {
      numberramerror = Constant.CORRECT_NUMBER_ERROR;
      if (!isNaN(value)) {
        let newvalue = value.trim() === "" ? "" : parseInt(value?.trim());
        formValues[name] = newvalue;
        numberramerror = "";
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          [name]: newvalue,
        }));
      }
    } else if (name === "sessions") {
      sessionerror = Constant.VALID_SESSION;
      if (!isNaN(value)) {
        sessionerror = Constant.SESSION_LIMIT;
        if (value >= 0 && value <= 25) {
          formValues[name] = value;
          sessionerror = "";
          setFormValues((prevFormValues) => ({
            ...prevFormValues,
            [name]: value?.trim(),
          }));
        }
      }
    } else if (name === "utilization") {
      utilizationerror = Constant.UTLIZATION_NUMBER_VALID;
      if (value === ".") {
        utilizationerror = "";
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          [name]: value?.trim(),
        }));
      } else {
        if (!isNaN(value)) {
          {
            utilizationerror = "";
            formValues[name] = value;

            setFormValues((prevFormValues) => ({
              ...prevFormValues,
              [name]: value?.trim(),
            }));
          }
        }
      }
    } else if (name === "discount") {
      discounterror = Constant.UTLIZATION_NUMBER_VALID;
      if (value === "" || value === "-") {
        discounterror = "";
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          [name]: value?.trim(),
        }));
      } else {
        if (!isNaN(value)) {
          if (value < -100) {
            discounterror = "Discount cannot be less than -100(%)";
            formValues[name] = "";

            setFormValues((prevFormValues) => ({
              ...prevFormValues,
              [name]: "",
            }));
          } else {
            discounterror = "";
            formValues[name] = value;

            setFormValues((prevFormValues) => ({
              ...prevFormValues,
              [name]: value?.trim(),
            }));
          }
        }
      }
    } else if (name === "seatCount") {
      seatcounterror = Constant.CORRECT_NUMBER_ERROR;
      if (!isNaN(value)) {
        formValues[name] = value;
        seatcounterror = "";
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          [name]: value?.trim(),
        }));
      }
    } else if (name === "hours") {
      hours = Constant.CORRECT_NUMBER_ERROR;
      if (!isNaN(value)) {
        let newvalue = value.trim() === "" ? "" : parseInt(value?.trim());
        formValues[name] = newvalue;
        hours = "";
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          [name]: newvalue,
        }));
      }
    } else if (name === "amHours") {
      amhours = Constant.CORRECT_NUMBER_ERROR;
      if (!isNaN(value)) {
        let newvalue = value.trim() === "" ? "" : parseInt(value?.trim());
        formValues[name] = newvalue;
        amhours = "";
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          [name]: newvalue,
        }));
      }
    } else if (name === "numberOfYears") {
      numberOfYearsError = Constant.VALID_NOOFYEARS;
      if (value.trim() === "") {
        formValues[name] = "";
        numberOfYearsError = "";
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          [name]: "",
        }));
      } else if (!isNaN(value)) {
        numberOfYearsError = Constant.NOOFYEARS_LIMIT;
        if (value >= 1 && value <= 10) {
          let newvalue = value.trim() === "" ? "" : parseInt(value?.trim());
          formValues[name] = newvalue;
          numberOfYearsError = "";
          setFormValues((prevFormValues) => ({
            ...prevFormValues,
            [name]: newvalue,
          }));
        }
      }
    } else {
      formValues[name] = value;
      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        [name]: value,
      }));
    }

    if (submitclick) {
      const validationErrors = Validation(
        formValues,
        optype?.cpqOpportunityType,
        submitclick,
      );
      setErrors(validationErrors);
    }
    if (name === "noOfRAMs") {
      setErrors((prevFormValues) => ({
        ...prevFormValues,
        numberram: numberramerror,
        numberram:
          numberramerror === "" && value?.trim() === ""
            ? Constant.NUMBER_REQUIRED
            : numberramerror,
      }));
    }
    if (name === "totalPotentialHeadCountOutside") {
      setErrors((prevFormValues) => ({
        ...prevFormValues,
        numbercount:
          numbercounterror === "" && value?.trim() === ""
            ? Constant.NUMBER_REQUIRED
            : numbercounterror,
      }));
    }
    if (name === "sessions") {
      setErrors((prevFormValues) => ({
        ...prevFormValues,
        session:
          sessionerror === "" &&
          value?.trim() === "" &&
          formValues.productId === 1
            ? Constant.SESSION_REQUIRED
            : sessionerror,
      }));
    }
    if (name === "utilization") {
      setErrors((prevFormValues) => ({
        ...prevFormValues,
        utilization:
          utilizationerror === "" &&
          value?.trim() === "" &&
          formValues.productId === 1
            ? Constant.UTLIZATION_NUMBER_REQUIRED
            : utilizationerror,
      }));
    }
    if (name === "discount") {
      setErrors((prevFormValues) => ({
        ...prevFormValues,
        discount: discounterror,
      }));
    }

    if (name === "amHours") {
      setErrors((prevFormValues) => ({
        ...prevFormValues,
        amHours:
          amhours === "" && value?.trim() === "" && formValues.productId === 1
            ? Constant.NUMBER_REQUIRED
            : amhours,
      }));
    }
    if (name === "additionalNotes") {
      setErrors((prevFormValues) => ({
        ...prevFormValues,
        additionalNotes:
          additionalNotes === "" && value?.trim() === ""
            ? Constant.NUMBER_REQUIRED
            : additionalNotes,
      }));
    }
    if (name === "numberOfYears") {
      setErrors((prevFormValues) => ({
        ...prevFormValues,
        numberOfYears:
          numberOfYearsError === "" &&
          value?.trim() === "" &&
          formValues.productId === 1
            ? Constant.NUMBER_REQUIRED
            : numberOfYearsError,
      }));
    }
  };

  const handleNumberOfYearsBlur = () => {
    if (formValues.numberOfYears === "" || formValues.numberOfYears === null) {
      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        numberOfYears: 1,
      }));
      setErrors((prevFormValues) => ({
        ...prevFormValues,
        numberOfYears: "",
      }));
    }
  };

  const [variationType, setVariationType] = useState(0);
  //Handle dropdown change events
  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      [name]: value,
    }));
    formValues[name] = value;
    if (submitclick) {
      const validationErrors = Validation(formValues, submitclick);
      setErrors(validationErrors);
    }
    switch (name) {
      case "productId":
        setProductVariationsList([
          ...productDetails.productVariations?.filter(
            (x) => x.productId === value,
          ),
        ]);
        setIsConsultingITDevShowCalculate(true);
        if (
          value !== AllProductsEnum.EVOLUTION &&
          value !== AllProductsEnum.WORKLIFE &&
          value !== AllProductsEnum.EAP &&
          value !== AllProductsEnum.WELLNESSCOACHING &&
          value !== AllProductsEnum.STUDENTASSIST &&
          value !== AllProductsEnum.TOTALSOURCE
        ) {
          setShowVariationAccordian(true);
        } else {
          setShowVariationAccordian(false);
        }

        setNonEapRows(nonEapRows);
        setNonEapData(nonEapInital);
        setIsNonEapEditable(false);
        setPricingStructureVal("");
        setPricingStructureUSDVal("");
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          productVariationId: 0,
          pricingStructureId: 0,
          sessions: 0,
          utilization: 0,
        }));
        setPricingStructureList([
          ...productDetails.pricingStructures.filter(
            (x) => x.productId === value,
          ),
        ]);
        productDetails.components.map((prodComp) => {
          prodComp.checked = prodComp.autoSelect;
          prodComp.disabled = prodComp.autoSelect && !prodComp.optional;
        });
        setComponentList([]);
        setComponentList([
          ...productDetails.components.filter((x) => x.productId === value),
        ]);
        hideAndShowVariationFields(formValues.productId);
        if (
          formValues.productId ===
            AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS ||
          !Object.values(CalculatedProducts).includes(formValues.productId)
        ) {
          const productComponents = [
            ...productDetails.productComponents.filter(
              (x) => x.productId === value,
            ),
          ];

          productComponents.map((prodComp) => {
            prodComp.checked = prodComp.autoSelect;
            prodComp.disabled = prodComp.autoSelect && !prodComp.optional;
          });
          console.log("productComponents ProductOnly", productComponents);
          setComponentList(productComponents);

          setVariationType(0);
          if (
            value === AllProductsEnum.EAP ||
            value === AllProductsEnum.EVOLUTION ||
            value === AllProductsEnum.TOTALSOURCE ||
            value === AllProductsEnum.STUDENTASSIST ||
            value === AllProductsEnum.WELLNESSCOACHING
          ) {
            setVariationType(1);
          }
          if (
            value === AllProductsEnum.WORKLIFE ||
            value === AllProductsEnum.ENHANCEDFINANCIALSERVICES ||
            value === AllProductsEnum.ENHANCEDLEGALSERVICES ||
            value === AllProductsEnum.HELPLINE
          ) {
            setVariationType(2);
          }
          if (
            value === AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS ||
            value === AllProductsEnum.PATHWAYS
          ) {
            setVariationType(3);
          }
          if (
            value === AllProductsEnum.GWQ ||
            value === AllProductsEnum.NEWPARENTRETURNTOWORK
          ) {
            setVariationType(4);
          }

          setShowVariationAccordian(true);
          console.log(variationType);
          setErrors((prevFormValues) => ({
            ...prevFormValues,
            pricingOption: "",
            utilization: "",
            session: "",
          }));
        }
        break;
      case "productVariationId":
        setRowData([]);
        if (value === 0) {
          setShowVariationAccordian(false);
        } else {
          const components = [
            ...productDetails.components.filter(
              (x) =>
                x.productVariationId === value &&
                x.productId === formValues.productId,
            ),
          ];
          components.map((item) => {
            item.checked = item.autoSelect;
            item.disabled = item.autoSelect && !item.optional;
          });
          console.log("components PV", components);
          setComponentList([]);
          setComponentList(components);
          let product = productDetails.products.find(
            (x) => x.id == formValues.productId,
          ).productName;
          if (
            product === ProductList.EAP ||
            product === ProductList.EVOLUTION ||
            product === ProductList.TOTALSOURCE ||
            product === ProductList.STUDENTASSIST ||
            product === ProductList.WELLNESSCOACH
          ) {
            setVariationType(1);
          }
          if (
            product === ProductList.WORKLIFE ||
            product === ProductList.ENHANCEDFINANCIALSETTING ||
            product === ProductList.ENHANCEDLEGALSERVICE ||
            product === ProductList.HELPLINE
          ) {
            setVariationType(2);
          }
          if (
            product === ProductList.BANK ||
            product === ProductList.PATHWAYS
          ) {
            setVariationType(3);
          }
          if (product === ProductList.GWQ || product === ProductList.NPRW) {
            setVariationType(4);
          }
          setShowVariationAccordian(true);

          var productComponentList = productDetails.components.filter(
            (x) =>
              x.productVariationId === value &&
              x.productId === formValues.productId,
          );
          productComponentList.forEach((x) => {
            x.defaultSelect = x.autoSelect;
          });
          setComponentList([...productComponentList]);

          getUtilizationDistribution(
            formValues.productId,
            value,
            formValues.quoteId,
          );
        }
        break;
      case "pricingStructureId":
        const obj = pricingStructureList.find((x) => x.id === value);
        setPricingStructureLbl(
          obj.pricingStructureName +
            ` ${crmData.currencyCode === "USD" ? "" : crmData.currencyCode}`,
        );
        setPricingStructureUSDLbl(obj.pricingStructureName + " USD");
        if (nonEapRowData && nonEapRowData[0]) {
          bindAllInPriceNonEAP(value, nonEapRowData[0]);
        }

        if (
          obj.id === PricingStructuresEnum.FLATFEE_BANKOFCASES &&
          formValues.productId ===
            AllProductsEnum.RETURNTOWORK_CANCERCARECOMPASS
        ) {
          setFieldIsVisible((previousValues) => ({
            ...previousValues,
            BANKOFCASES: true,
          }));
        }

        break;

      default:
        break;
    }
  };

  function hideAndShowVariationFields(productId) {
    //The visibility also ensures required field validation.
    if (
      productId === AllProductsEnum.EAP ||
      productId === AllProductsEnum.TOTALSOURCE ||
      productId === AllProductsEnum.STUDENTASSIST ||
      productId === AllProductsEnum.WELLNESSCOACHING
    ) {
      setFieldIsVisible((previousValues) => ({
        ...previousValues,
        HOURS: false,
        SESSION: true,
        UTILIZATION: true,
        PRICINGSTRUCTURE: true,
        AMHOURS:
          Object.values(CalculatedProducts).includes(productId) &&
          isProductNotLikeBOH(productId),
        SEATCOUNT: !Object.values(CalculatedProducts).includes(productId),
        ADDITIONALNOTES: false,
      }));

      if (productId === AllProductsEnum.WELLNESSCOACHING) {
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          sessions: 6,
        }));
        setFieldIsVisible((previousValues) => ({
          ...previousValues,
          SESSION: loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM ||
                    loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER ||
                    loggedUser?.userRole[0]?.id === UserRole.PRICINGVP,
        }));
      }
    } else if (
      productId === AllProductsEnum.EVOLUTION ||
      productId === AllProductsEnum.WORKLIFE ||
      productId === AllProductsEnum.ENHANCEDFINANCIALSERVICES ||
      productId === AllProductsEnum.ENHANCEDLEGALSERVICES ||
      productId === AllProductsEnum.HELPLINE
    ) {
      setFieldIsVisible((previousValues) => ({
        ...previousValues,
        HOURS: false,
        SESSION: false,
        UTILIZATION: true,
        PRICINGSTRUCTURE: true,
        AMHOURS:
          Object.values(CalculatedProducts).includes(productId) &&
          isProductNotLikeBOH(productId),
        SEATCOUNT: !Object.values(CalculatedProducts).includes(productId),
        ADDITIONALNOTES: productId === AllProductsEnum.HELPLINE,
      }));

      if (productId === AllProductsEnum.EVOLUTION) {
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          sessions: 10,
        }));
      }

      if (
        productId === AllProductsEnum.WORKLIFE ||
        productId === AllProductsEnum.ENHANCEDFINANCIALSERVICES ||
        productId === AllProductsEnum.ENHANCEDLEGALSERVICES
      ) {
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          sessions: 1,
        }));
      }
    } else if (
      productId === AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS ||
      productId === AllProductsEnum.PATHWAYS ||
      productId === AllProductsEnum.ORIENTATION ||
      productId === AllProductsEnum.RAPIDRESPONSECRITICALINCIDENTRRCI ||
      productId === AllProductsEnum.TRAINING
    ) {
      setFieldIsVisible((previousValues) => ({
        ...previousValues,
        HOURS: true,
        SESSION: false,
        UTILIZATION: false,
        PRICINGSTRUCTURE: true,
        AMHOURS:
          Object.values(CalculatedProducts).includes(productId) &&
          isProductNotLikeBOH(productId),
        SEATCOUNT: !Object.values(CalculatedProducts).includes(productId),
        ADDITIONALNOTES: true,
      }));
    } else if (
      productId === AllProductsEnum.GLOBALWELLBEINGQUESTIONNAIRE ||
      productId === AllProductsEnum.NEWPARENTRETURNTOWORK
    ) {
      setFieldIsVisible((previousValues) => ({
        ...previousValues,
        HOURS: false,
        SESSION: false,
        UTILIZATION: false,
        PRICINGSTRUCTURE: true,
        AMHOURS:
          Object.values(CalculatedProducts).includes(productId) &&
          isProductNotLikeBOH(productId),
        SEATCOUNT: !Object.values(CalculatedProducts).includes(productId),
        ADDITIONALNOTES: true,
      }));
    } else {
      setFieldIsVisible((previousValues) => ({
        ...previousValues,
        HOURS: true,
        SESSION: true,
        UTILIZATION: true,
        PRICINGSTRUCTURE: true,
        AMHOURS:
          Object.values(CalculatedProducts).includes(productId) &&
          isProductNotLikeBOH(productId),
        SEATCOUNT: !Object.values(CalculatedProducts).includes(productId),
        ADDITIONALNOTES: true,
      }));
    }
  }
  function getUtilizationDistribution(productId, productVariationId, quoteId) {
    dispatch(
      getServiceDistribution(
        Congiguration.CompanyId,
        productId,
        productVariationId,
        quoteId,
      ),
    )
      .then((data) => {
        bindServiceDistribution(data);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  function bindServiceDistribution(utilizationDistributionData) {
    const utilizationDistributionSet = new Set();
    const uniqueUtilizationDistributionKeys =
      utilizationDistributionData.utilizationDistributions.filter((item) => {
        const duplicate = utilizationDistributionSet.has(item.countryId);
        utilizationDistributionSet.add(item.countryId);
        return !duplicate;
      });
    setUtilizationDistributionByCountries(uniqueUtilizationDistributionKeys);
    setUtilizationDistributionRows([
      ...utilizationDistributionData.utilizationDistributions,
    ]);
    GetRowData(
      utilizationDistributionData.utilizationDistributions,
      utilizationDistributionData.components,
    );
  }
  const inputRef = useRef();
  function handleComponentError() {
    let validCalculation = true;
    let pricingOptionerror = "";
    let sessionerror = "";
    let utilizationerror = "";
    let hourserror = "";
    if (variationType <= 1) {
      if (!formValues.sessions && fieldIsVisible?.SESSION) {
        sessionerror = Constant.SESSION_REQUIRED;
        validCalculation = false;
      } else if (
        !/^[1-9][0-9]*$/.test(formValues.sessions) &&
        fieldIsVisible?.SESSION
      ) {
        sessionerror = Constant.VALID_SESSION;
        validCalculation = false;
      } else {
        if (formValues.sessions > 25 && fieldIsVisible?.SESSION) {
          validCalculation = false;
          sessionerror = Constant.SESSION_LIMIT;
        } else sessionerror = "";
      }
      setErrors((prevFormValues) => ({
        ...prevFormValues,
        session: sessionerror,
      }));
    }

    // Utilization Validation
    if (variationType <= 1) {
      if (!formValues.utilization && fieldIsVisible?.UTILIZATION) {
        utilizationerror = Constant.UTLIZATION_NUMBER_REQUIRED;
        validCalculation = false;
      } else if (
        !/^[0-9]*\.?[0-9]*$/.test(formValues.utilization) &&
        fieldIsVisible?.UTILIZATION
      ) {
        utilizationerror = Constant.UTLIZATION_NUMBER_VALID;
        validCalculation = false;
      } else {
        const utilizationNumber = parseFloat(formValues.utilization);
        if (utilizationNumber <= 0 && fieldIsVisible?.UTILIZATION) {
          utilizationerror = Constant.UTLIZATION_NUMBER_GREATER;
          validCalculation = false;
        } else {
          utilizationerror = "";
        }
      }
      setErrors((prevFormValues) => ({
        ...prevFormValues,
        utilization: utilizationerror,
      }));
    }
    // Pricing Structre Option Validation
    if (!formValues.pricingStructureId) {
      setPricingStructureVal("");
      setPricingStructureUSDVal("");
      pricingOptionerror = Constant.SELECT_OPTION;
      validCalculation = false;
    } else {
      pricingOptionerror = "";
    }
    setErrors((prevFormValues) => ({
      ...prevFormValues,
      pricingOption: pricingOptionerror,
    }));

    if (isProductLikeBOH(formValues.productId)) {
      if (Number(formValues.hours) === 0 && fieldIsVisible?.HOURS) {
        hourserror = Constant.VALID_HOURS;
        validCalculation = false;
      } else if (!formValues.hours && fieldIsVisible?.HOURS) {
        hourserror = Constant.HOURS_REQUIRED;
        validCalculation = false;
      } else if (
        !/^[0-9][0-9]*(\.[0-9]+)?$/.test(formValues.hours) &&
        fieldIsVisible?.HOURS &&
        formValues.hours <= 0
      ) {
        hourserror = Constant.VALID_HOURS;
        validCalculation = false;
      } else hourserror = "";

      setErrors((prevFormValues) => ({
        ...prevFormValues,
        hours: hourserror,
      }));
    }

    if (
      formValues.productId === AllProductsEnum.ENHANCEDLEGALSERVICES ||
      formValues.productId === AllProductsEnum.ENHANCEDFINANCIALSERVICES
    ) {
      if (!formValues.utilization && fieldIsVisible?.UTILIZATION) {
        utilizationerror = Constant.UTLIZATION_NUMBER_REQUIRED;
        validCalculation = false;
      } else if (
        !/^[0-9]*\.?[0-9]*$/.test(formValues.utilization) &&
        fieldIsVisible?.UTILIZATION
      ) {
        utilizationerror = Constant.UTLIZATION_NUMBER_VALID;
        validCalculation = false;
      } else {
        const utilizationNumber = parseFloat(formValues.utilization);
        if (utilizationNumber <= 0 && fieldIsVisible?.UTILIZATION) {
          utilizationerror = Constant.UTLIZATION_NUMBER_GREATER;
          validCalculation = false;
        } else {
          utilizationerror = "";
        }
      }
      setErrors((prevFormValues) => ({
        ...prevFormValues,
        utilization: utilizationerror,
      }));
    }

    return validCalculation;
  }
  const handleCalculateClick = () => {
    const selectedComponents = getSelectedComponents();

    if (
      formValues.productId ===
        AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS &&
      (!selectedComponents || selectedComponents === "")
    ) {
      setNotificationMessage("Please select a component!");
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
      setCalculateBtnLoading(false);
      setAllInPriceLoading(false);
      setLoadingState(false);
      return false;
    }

    const obJCalculate = {
      opportunityId: formValues.oppurtunityId,
      quoteId: formValues.quoteId,
      userId: loggedUser.user.id,
      numberOfSessionModels: formValues.sessions
        ? parseFloat(formValues.sessions)
        : 0,
      utilization: formValues.utilization
        ? parseFloat(formValues.utilization)
        : 0,
      productId: formValues.productId,
      productVariationId: formValues.productVariationId,
      requestedCurrencyId: formValues.currencyId,
      commission:
        crmData.commissionPercentage && crmData.commissionPercentage !== ""
          ? parseFloat(crmData.commissionPercentage)
          : formValues.commission && formValues.commission !== ""
            ? parseFloat(formValues.commission)
            : 0,
      discount: parseFloat(
        formValues.discount === "" ? 0 : formValues.discount,
      ),
      oppurtunityType: !optype?.cpqOpportunityType
        ? opportunityType
        : optype?.cpqOpportunityType,
      amHoursUI: formValues.amHours === "" ? 0 : formValues.amHours,
      productHours: formValues.hours,
      //companyId: Congiguration.CompanyId,
      seatCount: formValues.seatCount,
      pricingStructureId: formValues.pricingStructureId,
      componentIds: selectedComponents,
      numberOfYears: parseInt(formValues.numberOfYears),
    };

    let validCalculation = handleComponentError();
    if (validCalculation) {
      setLoadingState(true);
      setCalculateBtnLoading(true);
      setAllInPriceLoading(true);
      dispatch(getAllInPrice(obJCalculate))
        .then((data) => {
          if (data[0]) {
            if (data[0].revenueStage4TotalReqCurrency < data[0].floorMargin) {
              setNotificationMessage(
                "Revenue stage 4 is less than Floor margin! Please check calculation input values.",
              );
              setNotificationSeverity(Severity.WARNING);
              setShowNotification(true);
              setCalculateBtnLoading(false);
              setAllInPriceLoading(false);
              setLoadingState(false);
              //return false;
            }
          }
          console.log("calc", data);

          if (Object.keys(data).length !== 0) {
            bindAllInPrice(data, formValues.pricingStructureId);
          } else {
            setPricingStructureVal("");
            setPricingStructureUSDVal("");
          }
          setCalculateBtnLoading(false);
          setAllInPriceLoading(false);
          setLoadingState(false);
          setTimeout(
            () => inputRef?.current?.scrollIntoView({ behavior: "smooth" }),
            500,
          );
        })
        .catch((e) => {
          setCalculateBtnLoading(false);
          setAllInPriceLoading(false);
          setLoadingState(false);
          console.log(e);
        });
    }
  };

  function bindAllInPrice(allInPriceData, pricingStructureId) {
    let alInPrice = {};

    if (allInPriceData.length) {
      alInPrice = { ...allInPriceData[allInPriceData.length - 1] };
    }
    if (Object.keys(alInPrice).length !== 0) {
      setTcvCad(
        `CAD ${Number(alInPrice?.tcvcad?.toFixed(2)).toLocaleString("en", {
          useGrouping: true,
          roundingMode: "trunc",
          minimumFractionDigits: 2,
        })}`,
      );
      switch (pricingStructureId) {
        case PricingStructuresEnum.FFS:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FLATFEEQUARTERLY:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FFSPERCASE:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FFSPERSESSION:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FFSPERHOUR:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FLATFEEANNUAL:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.flatFeeAnnualTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.flatFeeAnnualTotalUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FLATFEEMONTHLY:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.flatFeeMonthlyTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.flatFeeMonthlyTotalUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.PEPM:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.pepmTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(alInPrice?.pepmTotalUSD?.toFixed(2)).toLocaleString(
              "en",
              {
                useGrouping: true,
                roundingMode: "trunc",
                minimumFractionDigits: 2,
              },
            )}`,
          );
          break;
        case PricingStructuresEnum.PEPY:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.pepyTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(alInPrice?.pepyTotalUSD?.toFixed(2)).toLocaleString(
              "en",
              {
                useGrouping: true,
                roundingMode: "trunc",
                minimumFractionDigits: 2,
              },
            )}`,
          );
          break;
        //fix
        case PricingStructuresEnum.FFSDONOTUSE:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FFSPERFULLDAY:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FFSPERPACKAGE:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.PROBONO:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.PEREMPLOYEEPERPOLICY:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FFSPER30MINUTECALL:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.PERCENTOFFEESPROCESSEDMONTHLY:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FFSPER40MINUTECALL:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FFSPERHALFDAY:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.PERPARTICIPANT:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FFSPERCALL:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.PERKIT:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FLATFEEONETIME:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;
        case PricingStructuresEnum.FLATFEE_BANKOFCASES:
          setPricingStructureVal(
            `${crmData.currencyCode}  ${Number(
              alInPrice?.ffsTotalReqCurrency?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          setPricingStructureUSDVal(
            `USD  ${Number(
              alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
            ).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            })}`,
          );
          break;

        default:
          setPricingStructureVal("");
          setPricingStructureUSDVal("");
          break;
      }
    }
  }

  const handleFile = async (e) => {
    const file = e.target.files[0];
    setShowButtons(false);
    setisValidCountriesUpload(true);
    setIsAccordianExpanded(false);
    setIsAccordianDisabled(true);
    if (file) {
      if (file.name.endsWith(".xlsx")) {
        try {
          const data = await file.arrayBuffer();
          const wb = read(data);
          const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet
          const filedata = utils.sheet_to_json(ws);
          if (
            filedata?.filter(
              (x) => x.Country === undefined || x.Headcount === undefined,
            ).length > 0
          ) {
            setNotificationMessage(Constant.MISSINGFIELDERROR);
            setNotificationSeverity(Severity.ERROR);
            setShowNotification(true);
            setCountryUploadFileName("");
            setIsCountriesFileUploaded(false);
          } else {
            const filterFileNegative = filedata.filter(
              (obj) =>
                obj.Headcount < 0 ||
                obj.Headcount === "" ||
                typeof obj.Headcount === "string",
            );
            if (filedata.length > 0 && filterFileNegative.length < 1) {
              const countryUpload = {
                countryHeadCountType: filedata.map((item) => {
                  return {
                    countryName: item.Country?.toString(),
                    headCount: item.Headcount,
                  };
                }),
                oppurtunityId: crmData.opportunityId,
                userId: loggedUser.user.id,
                companyId: Congiguration.CompanyId,
              };
              let seen = new Set();
              const hasDuplicates = countryUpload.countryHeadCountType.some(
                function (currentObject) {
                  return seen.size === seen.add(currentObject.countryName).size;
                },
              );
              if (hasDuplicates) {
                setNotificationMessage(
                  "Duplicate country found while confirming corrections! Please check and try again",
                );
                setNotificationSeverity(Severity.ERROR);
                setShowNotification(true);
                return false;
              } else {
                const uploadedCountries = {
                  countryHeadCountType: countryUpload.countryHeadCountType.map(
                    (item) => {
                      return {
                        countryName: item.countryName?.toString(),
                        headCount: item.headCount,
                      };
                    },
                  ),
                  companyId: Congiguration.CompanyId,
                };
                setCountryUploadFileName(file.name);
                setIsCountriesFileUploaded(true);
                setFormHeading(Constant.FORM_HEADING3);
                validateCountries(uploadedCountries);
                console.log("wb", filedata);
              }
            } else {
              if (filterFileNegative.length > 0) {
                setNotificationMessage(Constant.INVALIDHEADCOUNTERROR);
              } else {
                setNotificationMessage(Constant.EMPTYFILEERROR);
              }
              setNotificationSeverity(Severity.ERROR);
              setShowNotification(true);
              setCountryUploadFileName("");
              setIsCountriesFileUploaded(false);
            }
          }
        } catch (error) {
          setNotificationMessage(Constant.FILEUPLOADERROR);
          setNotificationSeverity(Severity.ERROR);
          setShowNotification(true);
          setCountryUploadFileName("");
          setIsCountriesFileUploaded(false);
          setLoadingState(false);
          e.target.value = null;
        }
      } else {
        setNotificationMessage(Constant.WRONGFILETYPE);
        setNotificationSeverity(Severity.ERROR);
        setShowNotification(true);
        setCountryUploadFileName("");
        setLoadingState(false);
        setIsCountriesFileUploaded(false);
      }
    }
    e.target.value = null;
  };
  function validateCountries(uploadedCountries) {
    dispatch(validateCountryHeadCount(uploadedCountries))
      .then((data) => {
        console.log(data);
        console.log(data.countries);
        setCountryValidationCountries([...data.countries]);
        setCountryValidationHeaders([...countryValidationHeadersValues]);
        setCountryValidationRows([...data.countryVariations]);
        if (
          data.countryVariations.filter((x) => x.isVariation === true).length >
          0
        ) {
          data.countryVariations.forEach((variation) => {
            console.log(variation);
            if (variation.isVariation) {
              setFormHeading(Constant.FORM_HEADING2);
              setisValidCountriesUpload(false);
              setNotificationMessage("Please correct the file upload errors!");
              setNotificationSeverity(Severity.ERROR);
              setShowNotification(true);
            }
          });
        } else {
          const updatedCountryHeadcount = [...data.countryVariations];

          const correctedCountries = {
            countryHeadCountType: updatedCountryHeadcount.map((item) => {
              return {
                countryName: item.variationName,
                headCount: item.headCount,
              };
            }),
            companyId: Congiguration.CompanyId,
          };

          let seen = new Set();
          const hasDuplicates = correctedCountries.countryHeadCountType.some(
            function (currentObject) {
              return seen.size === seen.add(currentObject.countryName).size;
            },
          );

          if (!hasDuplicates) {
            const countryUpload = {
              countryHeadCountType: updatedCountryHeadcount.map((item) => {
                return {
                  countryName: item.variationName,
                  headCount: item.headCount,
                };
              }),
              oppurtunityId: crmData.opportunityId,
              userId: loggedUser.user.id,
              companyId: Congiguration.CompanyId,
            };

            setisValidCountriesUpload(true);
            setIsAccordianExpanded(true);
            setIsAccordianDisabled(false);
            setFormHeading(Constant.FORM_HEADING3);
            let quoteId = UploadCountries(countryUpload);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
    return isValidCountriesUpload;
  }

  const handleConfirm = (event) => {
    if (
      countryValidationRows.filter((x) => x.isVariation === true).length === 0
    ) {
      setLoadingState(true);
      const updatedCountryHeadcount = [...countryValidationRows];
      const correctedCountries = {
        countryHeadCountType: updatedCountryHeadcount.map((item) => {
          return {
            countryName: item.variationName,
            headCount: item.headCount,
          };
        }),
        companyId: Congiguration.CompanyId,
      };

      let seen = new Set();
      const hasDuplicates = correctedCountries.countryHeadCountType.some(
        function (currentObject) {
          return seen.size === seen.add(currentObject.countryName).size;
        },
      );

      console.log(hasDuplicates, "hasDuplicates");
      console.log(correctedCountries, "updated data");
      if (!hasDuplicates) {
        const countryUpload = {
          countryHeadCountType: updatedCountryHeadcount.map((item) => {
            return {
              countryName: item.variationName,
              headCount: item.headCount,
            };
          }),
          oppurtunityId: crmData.opportunityId,
          userId: loggedUser.user.id,
          companyId: Congiguration.CompanyId,
        };

        setisValidCountriesUpload(true);
        setIsAccordianExpanded(true);
        setIsAccordianDisabled(false);
        setFormHeading(Constant.FORM_HEADING3);
        let quoteId = UploadCountries(countryUpload);

        if (quoteId) {
          dispatch(getQuoteCountryHeadCounts(formValues.quoteId))
            .then((data) => {
              console.log("country headcounts", data);
              const countryHeadCounts = data.map((item) => {
                return {
                  countryName: item.countryName,
                  headCount: item.headcount,
                };
              });
              setLoadingState(false);
              setCountryHeadCountDialogRows(countryHeadCounts);
            })
            .catch((e) => {
              console.log(e);
            });
        }
        // else {
        //     setNotificationMessage('Please confirm the corrections first!');
        //     setNotificationSeverity(Severity.WARNING);
        //     setShowNotification(true);
        //    setLoadingState(false);
        // }
      } else {
        setNotificationMessage(
          "Duplicate country found while confirming corrections! Please check and try again",
        );
        setNotificationSeverity(Severity.ERROR);
        setShowNotification(true);
        setLoadingState(false);
        return false;
      }
    } else {
      setNotificationMessage("Please confirm the corrections first!");
      setNotificationSeverity(Severity.WARNING);
      setShowNotification(true);
      setLoadingState(false);
    }
  };

  const handleSaveAsDraft = (event) => {
    event.preventDefault();
    setSubmit(true);
    setLoadingState(true);
    setDraftLoading(true);
    const validationErrors = Validation(
      formValues,
      opportunityType,
      fieldIsVisible,
      isConsultingITDevShowCalculate,
    );
    setErrors(validationErrors);
    const selectedComponents = getSelectedComponents();
    if (optype?.cpqOpportunityType === "RENEWAL") {
      delete validationErrors?.pastquotes;
      delete validationErrors?.currentutlization;
    }

    //handleComponentError();
    if (
      Object.keys(validationErrors).length > 0 ||
      (formValues.productId ===
        AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS &&
        (!selectedComponents || selectedComponents === ""))
    ) {
      Object.keys(validationErrors).length > 0
        ? setNotificationMessage("Please fill all the required fields")
        : setNotificationMessage("Please select a component!");
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
      setDraftLoading(false);
      setLoadingState(false);
      return false;
    } else {
      const currentDateTime = moment().format("YYYY-MM-DD");
      if (
        new Date(formValues.deadline).setHours(0, 0, 0, 0) <
        new Date(currentDateTime).setHours(0, 0, 0, 0)
      ) {
        setErrors((prevFormValues) => ({
          ...prevFormValues,
          deadlineDate: "Past date is not valid",
        }));
        setNotificationMessage("Please select future date for deadline!");
        setNotificationSeverity(Severity.ERROR);
        setShowNotification(true);
        setSubmitLoading(false);
        setLoadingState(false);
        setDraftLoading(false);
        return false;
      } else if (isDistributionEditable) {
        setNotificationMessage(
          "Please save the updated Utlilization Distribution %",
        );
        setNotificationSeverity(Severity.ERROR);
        setShowNotification(true);
        setSubmitLoading(false);
        setLoadingState(false);
        setDraftLoading(false);
        return false;
      } else if (isNonEapEditable) {
        setNotificationMessage(
          "Please save the updated Utlilization Distribution % for Non EAP",
        );
        setNotificationSeverity(Severity.ERROR);
        setShowNotification(true);
        setSubmitLoading(false);
        setLoadingState(false);
        setDraftLoading(false);
        return false;
      } else {
        const objQuote = { ...formValues };
        objQuote.sessions =
          formValues.sessions !== "" && formValues.sessions !== null
            ? parseFloat(formValues.sessions)
            : 0;
        objQuote.numberOfSessionModels =
          formValues.sessions !== "" && formValues.sessions !== null
            ? parseFloat(formValues.sessions)
            : 0;
        objQuote.utilization =
          formValues.utilization !== "" && formValues.utilization !== null
            ? parseFloat(formValues.utilization)
            : 0;
        objQuote.discount =
          formValues.discount !== "" && formValues.sesdiscountsions !== null
            ? parseFloat(formValues.discount)
            : 0;
        objQuote.amHours =
          formValues.amHours !== "" && formValues.amHours !== null
            ? parseFloat(formValues.amHours)
            : 0;
        objQuote.hours =
          formValues.hours !== "" && formValues.hours !== null
            ? parseFloat(formValues.hours)
            : 0;
        objQuote.seatCount =
          formValues.seatCount !== "" && formValues.seatCount !== null
            ? parseFloat(formValues.seatCount)
            : 0;
        objQuote.numberOfYears =
          formValues.numberOfYears !== "" && formValues.numberOfYears !== null
            ? parseInt(formValues.numberOfYears)
            : 0;

        const selectedComponents = getSelectedComponents();
        objQuote.componentIds = selectedComponents;

        console.log("selectedComponents", selectedComponents);

        objQuote.quoteStatusId = QuoteStatus.SAVEASDRAFT;
        objQuote.userId = loggedUser?.user?.id;
        dispatch(saveQuoteDetails(objQuote))
          .then((data) => {
            console.log("drft qte", data);
            //console.log("drft qte", data);
            setDraftLoading(false);
            setLoadingState(false);
            navigate("/viewquote", {
              state: {
                quoteId: formValues.quoteId,
              },
            });
            setDraftLoading(false);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    }
  };
  const handleGoback = (event) => {
    navigate(-1);
  };

  function getSelectedComponents() {
    let componentIds = "";

    if (componentList) {
      const components = [...componentList];
      console.log("getSelectedComponents", components);

      components.map((comp) => {
        if (comp.checked) {
          componentIds += comp.id + ",";
        }
      });
    }

    return componentIds.substring(0, componentIds.length - 1);
  }

  function saveQuote(
    objQuote,
    isDiscountChangedBySAMLeader,
    actionDone,
    quoteStatusBeforeSubmit,
  ) {
    dispatch(saveQuoteDetails(objQuote))
      .then((data) => {
        console.log("sv qte", data);
        setSubmitLoading(false);
        setLoadingState(false);
        navigate("/viewquote", {
          state: {
            quoteId: formValues.quoteId,
            isDiscountChanged: isDiscountChangedBySAMLeader,
            actionDone: actionDone,
            quoteStatusBeforeSubmit: quoteStatusBeforeSubmit,
          },
        });
        setSubmitLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmit(true);
    setSubmitLoading(true);
    setLoadingState(true);
    // Validate the field and update the errors
    const validationErrors = Validation(
      formValues,
      opportunityType,
      fieldIsVisible,
      isConsultingITDevShowCalculate,
    );
    const selectedComponents = getSelectedComponents();
    if (
      formValues.productId === AllProductsEnum.AMBASSADOR_PROGRAM &&
      (selectedComponents === "" ||
        selectedComponents === null ||
        selectedComponents === undefined)
    ) {
      validationErrors.component = "Please select at least one component";
    }
    if (!componentList) {
      setNotificationMessage("Please select a component!");
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
      setSubmitLoading(false);
      setLoadingState(false);
      return false;
    }

    setErrors(validationErrors);

    let actionDone = "";
    let quoteStatusBeforeSubmit = "";

    //handleComponentError();
    if (
      Object.keys(validationErrors).length > 0 ||
      (formValues.productId ===
        AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS &&
        (!selectedComponents || selectedComponents === ""))
    ) {
      Object.keys(validationErrors).length > 0
        ? setNotificationMessage("Please fill all the required fields")
        : setNotificationMessage("Please select a component!");
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
      setIsDistributionEditable(false);
      setEditMode(true);
      setSubmitLoading(false);
      setLoadingState(false);
      return false;
    } else {
      const currentDateTime = moment().format("YYYY-MM-DD");
      if (
        new Date(formValues.deadline).setHours(0, 0, 0, 0) <
        new Date(currentDateTime).setHours(0, 0, 0, 0)
      ) {
        setErrors((prevFormValues) => ({
          ...prevFormValues,
          deadlineDate: "Past date is not valid",
        }));
        setNotificationMessage("Please select future date for deadline!");
        setNotificationSeverity(Severity.ERROR);
        setShowNotification(true);
        setSubmitLoading(false);
        setLoadingState(false);
        return false;
      } else if (isDistributionEditable) {
        setNotificationMessage(
          "Please save the updated Utlilization Distribution %",
        );
        setNotificationSeverity(Severity.ERROR);
        setShowNotification(true);
        setSubmitLoading(false);
        setLoadingState(false);
        setDraftLoading(false);
        return false;
      } else if (isNonEapEditable) {
        setNotificationMessage(
          "Please save the updated Utlilization Distribution % for Non EAP",
        );
        setNotificationSeverity(Severity.ERROR);
        setShowNotification(true);
        setSubmitLoading(false);
        setLoadingState(false);
        setDraftLoading(false);
        return false;
      }

      const objQuote = { ...formValues };
      quoteStatusBeforeSubmit = objQuote.quoteStatusId;
      objQuote.discount =
        objQuote.discount === "" || objQuote.discount === "-"
          ? 0
          : !isNaN(objQuote.discount)
            ? parseFloat(objQuote.discount)
            : 0;

      const selectedComponents = getSelectedComponents();
      objQuote.componentIds = selectedComponents;
      console.log("selectedComponents", selectedComponents);
      if (
        loggedUser?.userRole[0]?.id === UserRole.SAMTEAM ||
        state?.requestType === "Create" ||
        objQuote.quoteStatusId === QuoteStatus.QUOTEPENDINGINITIALREQUESTOR ||
        ((loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM ||
          loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER ||
          loggedUser?.userRole[0]?.id === UserRole.PRICINGVP ||
          loggedUser?.userRole[0]?.id === UserRole.SAMLEADERSHIPTEAM ||
          loggedUser?.userRole[0]?.id === UserRole.SAMLEADERSHIPTEAMLEVEL3) &&
          (state?.requestType === "Create" ||
            state?.requestType === "Edit" ||
            state?.requestType === "Duplicate") &&
          (objQuote.quoteStatusId === QuoteStatus.SAVEASDRAFT ||
            objQuote.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGTEAM))
      ) {
        objQuote.quoteStatusId = QuoteStatus.QUOTEPENDINGPRICINGTEAM;
      }

      let isDiscountChangedBySAMLeader = null;

      if (
        objQuote.discount != existingDiscountValue &&
        (loggedUser?.userRole[0]?.id === UserRole.SAMLEADERSHIPTEAM ||
          loggedUser?.userRole[0]?.id === UserRole.SAMLEADERSHIPTEAMLEVEL3)
      ) {
        isDiscountChangedBySAMLeader = true;
      }

      if (isDiscountChangedBySAMLeader === null) {
        const isQuoteDiscountSession = isJsonString(
          sessionStorage.getItem(LocalStorageKeys.ISDISCOUNTCHANGED),
        )
          ? JSON.parse(
              sessionStorage.getItem(LocalStorageKeys.ISDISCOUNTCHANGED),
            )
          : null;
        isDiscountChangedBySAMLeader =
          isQuoteDiscountSession !== null &&
          isQuoteDiscountSession.quoteId == objQuote.quoteId
            ? isQuoteDiscountSession.isDiscount
            : false;
      } else {
        const isQuoteDiscount = JSON.stringify({
          quoteId: objQuote.quoteId,
          isDiscount: isDiscountChangedBySAMLeader,
        });
        sessionStorage.setItem(
          LocalStorageKeys.ISDISCOUNTCHANGED,
          isQuoteDiscount,
        );
      }

      objQuote.isDiscount = isDiscountChangedBySAMLeader;

      if (
        state?.requestType === "Create" ||
        state?.requestType === "Duplicate"
      ) {
        actionDone = "Created";
      } else {
        if (currentQuoteStatusId === QuoteStatus.SAVEASDRAFT) {
          actionDone = "Draft";
        } else {
          actionDone = "Updated";
        }
      }

      objQuote.userId = loggedUser?.user?.id;
      objQuote.sessions =
        formValues.sessions !== "" && formValues.sessions !== null
          ? parseFloat(formValues.sessions)
          : 0;
      objQuote.numberOfSessionModels =
        formValues.sessions !== "" && formValues.sessions !== null
          ? parseFloat(formValues.sessions)
          : 0;
      objQuote.utilization =
        formValues.utilization !== "" && formValues.utilization !== null
          ? parseFloat(formValues.utilization)
          : 0;
      objQuote.discount =
        formValues.discount !== "" && formValues.discount !== null
          ? parseFloat(formValues.discount)
          : 0;
      objQuote.amHours =
        formValues.amHours !== "" && formValues.amHours !== null
          ? parseFloat(formValues.amHours)
          : 0;
      objQuote.hours =
        formValues.hours !== "" && formValues.hours !== null
          ? parseFloat(formValues.hours)
          : 0;
      objQuote.seatCount =
        formValues.seatCount !== "" && formValues.seatCount !== null
          ? parseFloat(formValues.seatCount)
          : 0;
      objQuote.numberOfYears =
        formValues.numberOfYears !== "" && formValues.numberOfYears !== null
          ? parseInt(formValues.numberOfYears)
          : 0;

      if (
        formValues.productId !==
          AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS &&
        formValues.productId !== AllProductsEnum.PATHWAYS &&
        formValues.productId !== AllProductsEnum.ORIENTATION &&
        formValues.productId !==
          AllProductsEnum.RAPIDRESPONSECRITICALINCIDENTRRCI &&
        formValues.productId !== AllProductsEnum.TRAINING &&
        formValues.productId !== AllProductsEnum.RETURNTOWORK_CANCERCARECOMPASS
      ) {
        objQuote.hours = 0;
      }

      //Save Non-EAP quote
      if (!Object.values(CalculatedProducts).includes(formValues.productId)) {
        const obj = {
          discount: !isNaN(formValues.discount)
            ? parseFloat(formValues.discount)
            : 0,
          quoteId: formValues.quoteId,
          commissionPercent:
            !isNaN(formValues.commission) || formValues.commission !== ""
              ? parseFloat(formValues.commission)
              : 0,
          revenueStage1ReqCurrency: !isNaN(nonEapData?.revenueStage1ReqCurrency)
            ? parseFloat(nonEapData?.revenueStage1ReqCurrency)
            : 0,
          revenueStage1USD: !isNaN(nonEapData?.revenueStage1USD)
            ? parseFloat(nonEapData?.revenueStage1USD)
            : 0,
          revenueStage2ReqCurrency: !isNaN(nonEapData?.revenueStage2ReqCurrency)
            ? parseFloat(nonEapData?.revenueStage2ReqCurrency)
            : 0,
          revenueStage2USD: !isNaN(nonEapData?.revenueStage2USD)
            ? parseFloat(nonEapData?.revenueStage2USD)
            : 0,
          ffsAnnualUSD: !isNaN(nonEapData?.ffsAnnualUSD)
            ? parseFloat(nonEapData?.ffsAnnualUSD)
            : 0,
          ffsReqCurrency: !isNaN(nonEapData?.ffsReqCurrency)
            ? parseFloat(nonEapData?.ffsReqCurrency)
            : 0,
          userId: loggedUser?.user?.id,
          numberOfYears: parseInt(formValues?.numberOfYears),
        };
        dispatch(SaveQuoteCalculationsNonEAP(obj))
          .then((data) => {
            console.log("SaveQuoteCalculationsNonEAP On Submit", data);
          })
          .catch((e) => {
            console.log(e);
          });
        saveQuote(
          objQuote,
          isDiscountChangedBySAMLeader,
          actionDone,
          quoteStatusBeforeSubmit,
        );
      }
      //Save EAP quote
      else {
        const obJCalculate = {
          opportunityId: formValues.oppurtunityId,
          quoteId: formValues.quoteId,
          userId: loggedUser.user.id,
          numberOfSessionModels:
            formValues.sessions &&
            formValues.sessions !== "" &&
            formValues.sessions !== null
              ? parseFloat(formValues.sessions)
              : 0,
          utilization:
            formValues.utilization &&
            formValues.utilization !== "" &&
            formValues.utilization !== null
              ? parseFloat(formValues.utilization)
              : 0,
          productId: formValues.productId,
          productVariationId: formValues.productVariationId,
          requestedCurrencyId: formValues.currencyId,
          commission:
            crmData.commissionPercentage && crmData.commissionPercentage !== ""
              ? parseFloat(crmData.commissionPercentage)
              : formValues.commission && formValues.commission !== ""
                ? parseFloat(formValues.commission)
                : 0,
          discount:
            formValues.discount !== "" && formValues.discount !== null
              ? parseFloat(formValues.discount)
              : 0,
          oppurtunityType: !optype?.cpqOpportunityType
            ? opportunityType
            : optype?.cpqOpportunityType,
          amHoursUI:
            formValues.amHours !== "" && formValues.amHours !== null
              ? parseFloat(formValues.amHours)
              : 0,
          productHours:
            formValues.hours !== "" && formValues.hours !== null
              ? parseFloat(formValues.hours)
              : 0,
          //companyId: Congiguration.CompanyId,
          seatCount:
            formValues.seatCount !== "" && formValues.seatCount !== null
              ? parseFloat(formValues.seatCount)
              : 0,
          pricingStructureId: formValues.pricingStructureId,
          componentIds: selectedComponents,
          numberOfYears: parseInt(formValues?.numberOfYears),
        };
        //Get calculation & check revenueStage4 should not be less than floorMargin
        dispatch(getAllInPrice(obJCalculate))
          .then((data) => {
            console.log("calc during save revStg4 & flrMrgn", data);

            if (data[0]) {
              if (data[0].revenueStage4TotalReqCurrency < data[0].floorMargin) {
                setShowConfirmation(true);
                setQuoteObject(objQuote);
                setIsDiscountUpdated(isDiscountChangedBySAMLeader);
                setActionDone(actionDone);
                setQuoteStatus(quoteStatusBeforeSubmit);

                setLoadingState(false);

                setCalculateBtnLoading(false);
                setAllInPriceLoading(false);
                setSubmitLoading(false);
              } else {
                saveQuote(
                  objQuote,
                  isDiscountChangedBySAMLeader,
                  actionDone,
                  quoteStatusBeforeSubmit,
                );
              }
            } else {
              saveQuote(
                objQuote,
                isDiscountChangedBySAMLeader,
                actionDone,
                quoteStatusBeforeSubmit,
              );
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    }
  };

  function getFormattedToday() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const closeNotificationPopup = () => {
    setShowNotification(false);
  };

  const closeCountryHeadCountDialog = () => {
    setShowCountryHeadCountDialog(false);
  };
  const closeDuplicateCountryHeadCountDialog = () => {
    setShowCountryDialog(false);
    setDuplicateCountryList([]);
  };

  const handleViewCountryHeadCountsButtonClick = () => {
    if (formValues.quoteId) {
      dispatch(getQuoteCountryHeadCounts(formValues.quoteId))
        .then((data) => {
          console.log("country headcounts", data);
          let viewcountryHeadcount = data.map((item) => {
            return {
              countryName: item.countryName,
              headcount: item.headcount,
              countryId: item.countryId,
              isChecked: false,
            };
          });
          setCountryHeadCountDialogRows([...viewcountryHeadcount]);
          setShowCountryHeadCountDialog(true);
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      setNotificationMessage("Please confirm the corrections first!");
      setNotificationSeverity(Severity.WARNING);
      setShowNotification(true);
    }
  };
  const handleDuplicateViewCountryHeadCountsButtonClick = () => {
    setNewHeadcountError("");
    setNewCountryError("");
    setNewCountryHeadCount({ headcount: "", country: 0 });
    if (formValues.quoteId) {
      dispatch(getQuoteCountryHeadCounts(formValues.quoteId))
        .then((data) => {
          console.log("country headcounts", data);
          let viewcountryHeadcount = data.map((item) => {
            return {
              countryName: item.countryName,
              headcount: item.headcount,
              countryId: item.countryId,
              isChecked: false,
            };
          });
          setCountryHeadCountDialogRows([...viewcountryHeadcount]);
          setShowCountryDialog(true);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };
  const handleCountryChanges = (event) => {
    const index = countryHeadCountDialogRows.findIndex(
      (x) => x.countryId == event.target.value,
    );
    if (index !== -1) {
      const updatedData = [...countryHeadCountDialogRows];
      updatedData[index] = {
        ...updatedData[index],
        isChecked: event.target.checked,
      };
      setCountryHeadCountDialogRows(updatedData);
    }
    var country_array = [...duplicateCountryList];
    if (event.target.checked) {
      country_array = [...duplicateCountryList, event.target.value];
    } else {
      country_array.splice(duplicateCountryList.indexOf(event.target.value), 1);
    }
    setDuplicateCountryList(country_array);
  };

  const handleSelectCountryChange = (event) => {
    const newValue = event.target.value;
    setNewCountryHeadCount((prevFormValues) => ({
      ...prevFormValues,
      country: newValue,
    }));
    setNewCountryError("");
  };
  const handleTextboxHeadCountChange = (event) => {
    const newValue = event.target.value.trim();
    if (isNaN(newValue) || parseFloat(newValue) < 0) {
      setNewHeadcountError(Constant.CORRECT_NUMBER_ERROR);
      event.target.value = "";
    } else if (!Number.isInteger(parseFloat(newValue)) && newValue != 0) {
      setNewHeadcountError(Constant.CORRECT_NUMBER_ERROR);
      event.target.value = "";
    } else {
      event.target.value = Math.floor(event.target.value);
      if (newValue > Constant.MAXSAFEINTEGER) {
        setNewHeadcountError(Constant.LIMITERROR);
      } else {
        setNewHeadcountError("");
      }
      setNewCountryHeadCount((prevFormValues) => ({
        ...prevFormValues,
        headcount: newValue == "" ? "" : parseInt(newValue),
      }));
    }
  };

  const SaveCountryHeadCount = () => {
    console.log(duplicateCountryList);
    if (duplicateCountryList.length > 0) {
      if (duplicateCountryList.length === countryHeadCountDialogRows.length) {
        setNotificationMessage(Constant.COUNTRYERROR);
        setNotificationSeverity(Severity.INFO);
        setShowNotification(true);
      } else {
        const removedCountrIds = duplicateCountryList.join(",");
        const removeCountries = {
          quoteId: formValues.quoteId,
          countryIds: removedCountrIds,
        };
        setLoadingState(true);
        dispatch(removeQuoteCountries(removeCountries))
          .then((data) => {
            console.log("country headcounts", data);
            const countryHeadCounts = data.map((item) => {
              return {
                countryName: item.countryName,
                headCount: item.headcount,
              };
            });
            let viewcountryHeadcount = data.map((item) => {
              return {
                countryName: item.countryName,
                headcount: item.headcount,
                countryId: item.countryId,
                isChecked: false,
              };
            });
            const headCount = countryHeadCounts.reduce(
              (accumulator, object) => {
                return accumulator + object.headCount;
              },
              0,
            );
            setCountryHeadCountList(countryHeadCounts);
            setSumHeadCounts(headCount?.toLocaleString());
            getUtilizationDistribution(
              formValues.productId,
              formValues.productVariationId,
              formValues.quoteId,
            );
            setNotificationMessage(Constant.COUNTRYUPDATESUCCESS);
            setNotificationSeverity(Severity.SUCCESS);
            setShowNotification(true);
            setLoadingState(false);
            setDuplicateCountryList([]);
            setCountryHeadCountDialogRows(viewcountryHeadcount);
          })
          .catch((e) => {
            console.log(e);
          });
        setDuplicateCountryList([]);
      }
    } else {
      setNotificationMessage("No Changes");
      setNotificationSeverity(Severity.INFO);
      setShowNotification(true);
      setShowCountryHeadCountDialog(false);
    }
  };
  const handleEditButtonClick = () => {
    setutilizationDistributionOriginal([...utilizationDistributionRows]);
    setHeaderData(() => [...defaultHeader, ...editableComponentData]);
    setIsSaveClicked(false);
    if (editMode) {
      setEditMode(false);
      setIsDistributionEditable(true);
    } else {
      setEditMode(true);
      setIsDistributionEditable(false);
    }
  };
  useEffect(() => {
    if (serviceDistributionList.length > 0 && isSaveClicked) {
      console.log(
        arraysEqual(serviceDistributionList, oldServiceDistributionList),
      );
      if (!arraysEqual(serviceDistributionList, oldServiceDistributionList)) {
        setoldServiceDistributionList([...serviceDistributionList]);
        handleSaveButtonClick();
      }
    }
  }, [serviceDistributionList, isSaveClicked]);

  const arraysEqual = (a1, a2) =>
    a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));
  const objectsEqual = (o1, o2) =>
    typeof o1 === "object" && Object.keys(o1).length > 0
      ? Object.keys(o1).length === Object.keys(o2).length &&
        Object.keys(o1).every((p) => objectsEqual(o1[p], o2[p]))
      : o1 === o2;
  const handleSaveClick = () => {
    if (!isRowUpdated) {
      setNotificationMessage("No changes to save");
      setNotificationSeverity(Severity.INFO);
      setShowNotification(true);
      setHeaderData(() => [...defaultHeader, ...componentData]);
      setIsDistributionEditable(false);
    } else {
      setIsSaveClicked(true);
    }
  };
  const handleSaveButtonClick = () => {
    if (isSaveClicked) {
      if (serviceDistributionList.length > 0) {
        let isValid = true;
        let errorCountries = [];
        let errorMessageCountries = "";
        let errorMessage = "";
        let sumOfDistribution = 0.0;
        utilizationDistributionCountries.map((countryRecord) => {
          let checkSum = 0.0;
          const compUtilArr = utilizationDistributionRows.filter(
            (x) => x.countryId === countryRecord.countryId,
          );
          compUtilArr.map((compUtil) => {
            var changedValue = serviceDistributionList.find(
              (x) =>
                x.countryId === countryRecord.countryId &&
                x.componentId ===
                  editableComponentData?.find((x) =>
                    x.headerName.includes(compUtil.componentName),
                  )?.componentId,
            )?.utilizationPercent;
            const value = changedValue
              ? changedValue
              : compUtil.utilizationPercent !== ""
                ? parseFloat(compUtil.utilizationPercent)
                : 0.0;
            checkSum += parseFloat(value);
          });
          console.log(checkSum + " " + countryRecord.countryName, "sum");
          sumOfDistribution = checkSum;
          isValid = parseFloat(checkSum.toFixed(1)) === 100.0;

          if (!isValid) {
            errorCountries.push(countryRecord.countryName);
          }
        });

        if (isNaN(sumOfDistribution)) {
          errorMessage += "Invalid data input : Please check input values!";
        } else {
          errorMessage +=
            "Overall Utilization % should be equal to 100! Please check the input values.";
        }

        errorCountries.map((country) => {
          errorMessageCountries += country + " ";
        });
        errorMessageCountries += " : ";
        if (errorCountries.length > 0) {
          setNotificationMessage(errorMessageCountries + errorMessage);
          setNotificationSeverity(Severity.ERROR);
          setShowNotification(true);
          setIsDistributionEditable(true);
          setEditMode(false);
          return false;
        }

        const obj = {
          serviceDistributionVariations: serviceDistributionList,
          quoteId: formValues.quoteId,
          companyId: Congiguration.CompanyId,
          userId: loggedUser?.user.id,
        };
        console.log(obj);
        setLoadingState(true);
        setHeaderData(() => [...defaultHeader, ...componentData]);

        dispatch(saveServiceDistribution(obj))
          .then((data) => {
            if (data === 1) {
              setNotificationMessage(
                "Utilization Distribution saved successfully!",
              );
              setNotificationSeverity(Severity.SUCCESS);
              setShowNotification(true);
              setIsDistributionEditable(false);
              setServiceDistributionList([]);
              getUtilizationDistribution(
                formValues.productId,
                formValues.productVariationId,
                formValues.quoteId,
              );
            }
            console.log("save srv dist", data);
            setLoadingState(false);
          })
          .catch((e) => {
            console.log(e);
          });
        setIsRowUpdate(false);
      }
    }
  };

  //#region Unused fns
  const handleCancelButtonClick = () => {
    console.log(utilizationDistributionOriginal);
    setUtilizationDistributionRows([...utilizationDistributionOriginal]);
    setEditMode(true);
    setIsDistributionEditable(false);
  };
  const handleApprove = (event) => {
    event.preventDefault();
    setSubmit(true);
    // Validate the field and update the errors

    const validationErrors = Validation(formValues);
    setErrors(validationErrors);
    //handleComponentError();
    if (Object.keys(validationErrors).length > 0) {
      setNotificationMessage("Please fill all the required fields");
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
      setIsDistributionEditable(false);
      setEditMode(true);
      return false;
    } else {
      const objQuote = { ...formValues };

      if (
        objQuote.discount > 0 &&
        objQuote.discount != existingDiscountValue &&
        (loggedUser?.userRole[0]?.id === UserRole.SAMLEADERSHIPTEAM || 
          loggedUser?.userRole[0]?.id === UserRole.SAMLEADERSHIPTEAMLEVEL3)
      ) {
        objQuote.quoteStatusId = QuoteStatus.QUOTEPENDINGPRICINGTEAM;
      } else {
        objQuote.quoteStatusId = QuoteStatus.QUOTEAPPROVED;
      }

      objQuote.userId = loggedUser?.user?.id;
      dispatch(saveQuoteDetails(objQuote))
        .then((data) => {
          console.log("sv qte", data);
          navigate("/viewquote", {
            state: {
              quoteId: formValues.quoteId,
            },
          });
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const handleReject = (event) => {
    event.preventDefault();
    setSubmit(true);
    // Validate the field and update the errors

    const validationErrors = Validation(formValues);
    setErrors(validationErrors);
    //handleComponentError();
    if (Object.keys(validationErrors).length > 0) {
      setNotificationMessage("Please fill all the required fields");
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
      setIsDistributionEditable(false);
      setEditMode(true);
      return false;
    } else {
      const objQuote = { ...formValues };

      objQuote.quoteStatusId = QuoteStatus.QUOTEPENDINGSAMLEADERSHIP;
      objQuote.userId = loggedUser?.user?.id;
      dispatch(saveQuoteDetails(objQuote))
        .then((data) => {
          console.log("sv qte", data);
          navigate("/viewquote", {
            state: {
              quoteId: formValues.quoteId,
            },
          });
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const handleClick = (event) => {
    setShowCommentText(event.target.checked);
  };
  //#endregion

  //#region rfp file
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setLoadingState(true);
    if (file) {
      const formData = new FormData();
      try {
        formData.append("localPath", file);
        let splitedfilename = file.name.split(".");
        splitedfilename.pop();
        let name = splitedfilename.join(".");
        if (name?.length > Constant.FILENAMEMAXLENGTH) {
          setNotificationMessage(Constant.LONGNAMEERROR);
          setNotificationSeverity(Severity.ERROR);
          setShowNotification(true);
          setLoadingState(false);
        } else if (file?.size > Constant.FILEMAXSIZEINBYTE) {
          setNotificationMessage(Constant.FILESIZEEXCEEDERROR);
          setNotificationSeverity(Severity.ERROR);
          setShowNotification(true);
          setLoadingState(false);
        } else {
          uploadRFPFile(formValues.quoteId + "_" + name, formData)
            .then((result) => {
              if (!result?.data?.error) {
                setNotificationMessage(file.name + " saved successfully");
                setNotificationSeverity(Severity.SUCCESS);
                setShowNotification(true);
                setSelectedFile(file.name);

                setFormValues((prevFormValues) => ({
                  ...prevFormValues,
                  rfpFileName: result?.data?.blob?.name,
                }));
                setLoadingState(false);
              } else {
                setNotificationMessage(Constant.FILEUPLOADERROR);
                setNotificationSeverity(Severity.ERROR);
                setShowNotification(true);
                setLoadingState(false);
              }
            })
            .catch((e) => {
              console.log(e);
              setNotificationMessage(Constant.FILEUPLOADERROR);
              setNotificationSeverity(Severity.ERROR);
              setShowNotification(true);
              setLoadingState(false);
              event.target.value = null;
            });
        }
      } catch (error) {
        setNotificationMessage(Constant.FILEUPLOADERROR);
        setNotificationSeverity(Severity.ERROR);
        setShowNotification(true);
        setLoadingState(false);
        event.target.value = null;
      }
    }
    //setLoadingState(false);
    // event.target.value = null;
  };
  const handleReupload = () => {
    setSelectedFile(null);
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      rfpFileName: null,
    }));
  };

  const handledownload = () => {
    dispatch(downloadRFPFile(formValues.rfpFileName))
      .then((data) => {
        if (data) {
          const url = window.URL.createObjectURL(new Blob([data]));
          const file = new Blob([data]);

          // const quoteIdFileName = quoteId['quoteId'];
          saveAs.saveAs(file, selectedFile);
        }
        console.log("save srv dist", data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleConfirmSubmitPopup = () => {
    setSubmitLoading(true);
    setShowConfirmation(false);
    dispatch(saveQuoteDetails(quoteObject))
      .then((data) => {
        console.log("sv qte", data);
        setSubmitLoading(false);
        setLoadingState(false);
        navigate("/viewquote", {
          state: {
            quoteId: formValues.quoteId,
            isDiscountChanged: isDiscountUpdated,
            actionDone: actionDone,
            quoteStatusBeforeSubmit: quoteStatus,
          },
        });
        setSubmitLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const closConfirmationPopup = () => {
    setShowConfirmation(false);
  };

  //#endregion

  //#region  service distribution
  const defaultHeader = [
    {
      field: "countryName",
      headerName: "Country",
      align: "center",
      sortable: true,
      height: 70,
      width: 160,
      headerAlign: "center",
      edit: false,
      headerClassName: "grid-header",
    },
    {
      field: "headcount",
      headerName: "Head Count",
      align: "center",
      sortable: true,
      height: 70,
      width: 140,
      headerAlign: "center",
      edit: false,
      headerClassName: "grid-header",
    },
    {
      field: "productName",
      headerName: "Product",
      align: "center",
      sortable: false,
      height: 70,
      width: 100,
      headerAlign: "center",
      edit: false,
      headerClassName: "grid-header",
    },
    {
      field: "productVariationName",
      headerName: "Product Variation Name",
      sortable: false,
      edit: false,
      height: 70,
      width: 200,
      headerAlign: "center",
      headerClassName: "grid-header",
      cellClassName: "grid-cell",
      align: "center",
    },
  ];
  const [rowData, setRowData] = useState([]);
  const [headerData, setHeaderData] = useState(defaultHeader);
  const [componentData, setComponentData] = useState([]);
  const [editableComponentData, setEditableComponentData] = useState([]);
  function GetRowData(data, header) {
    setEditMode(true);
    setIsDistributionEditable(false);
    setRowData([]);
    let rowId = 1;
    const result = data?.reduce((acc, obj) => {
      const {
        countryName,
        countryId,
        headcount,
        productName,
        productId,
        componentName,
        utilizationPercent,
        productVariationName,
        productVariationId,
      } = obj;
      const existingRow = acc.find(
        (row) =>
          row.countryName === countryName &&
          row.productName === productName &&
          row.productVariationName === productVariationName &&
          row.headcount === headcount,
      );
      if (!existingRow) {
        const newRow = {
          countryId,
          productId,
          productVariationId,
          countryName,
          productName,
          productVariationName,
          headcount,
        };
        newRow[toVariableNameFormat(componentName)] = utilizationPercent;
        newRow.Id = rowId;
        rowId++;
        acc.push(newRow);
      } else {
        existingRow[toVariableNameFormat(componentName)] = utilizationPercent;
      }
      return acc;
    }, []);
    const itemSet = new Set(
      data
        .map((item) => JSON.stringify([item?.componentName, item.componentId]))
        .filter(
          (componentName) =>
            componentName !== undefined &&
            componentName !== "" &&
            componentName !== null,
        ),
    );

    const editableheader = header.map((item) => ({
      componentId: item.componentId,
      field: toVariableNameFormat(item.componentName),
      headerName: `${item.componentName} %`,
      sortable: false,
      editable: true,
      height: 70,
      width: 120,
      headerClassName: "grid-header",
      headerAlign: "center",
      align: "center",
    }));

    setEditableComponentData([...editableheader]);
    const newColumns = header.map((item) => ({
      componentId: item.componentId,
      field: toVariableNameFormat(item.componentName),
      headerName: `${item.componentName} %`,
      sortable: false,
      editable: false,
      height: 70,
      width: 120,
      headerClassName: "grid-header",
      headerAlign: "center",
      align: "center",
    }));
    setComponentData(newColumns);
    setHeaderData((prevArray) => [...defaultHeader, ...newColumns]);

    setRowData([...result]);
    console.log(renderKey, result);
    setRenderKey((prevKey) => prevKey + 1);
  }
  const onRowChange = (updatedRow) => {
    const updatedObjects = utilizationDistributionRows.filter(
      (x) =>
        x.countryId === updatedRow.countryId &&
        x.productId === updatedRow.productId &&
        x.productVariationId === updatedRow.productVariationId,
    );
    const newArray = [...serviceDistributionList];
    updatedObjects.map((obj) => {
      editableComponentData.map((column) => {
        if (obj.componentId === column.componentId) {
          if (obj.utilizationPercent != updatedRow[column.field]) {
            obj.utilizationPercent = updatedRow[column.field];

            const modifiedServiceDistribution = {
              countryId: obj.countryId,
              productId: obj.productId,
              productVariationId: obj.productVariationId,
              componentId: obj.componentId,
              utilizationPercent:
                obj.utilizationPercent === "" ? 0 : obj.utilizationPercent,
            };
            const result = newArray.findIndex(
              (x) =>
                x.countryId === obj.countryId &&
                x.productId === obj.productId &&
                x.productVariationId &&
                x.componentId === obj.componentId,
            );

            if (result !== -1) {
              newArray.splice(result, 1, modifiedServiceDistribution);
            } else {
              newArray.push(modifiedServiceDistribution);
            }
          }
        }
      });
    });
    let negative = false;
    editableComponentData.forEach((column) => {
      let value = updatedRow[column.field];
      if (value < 0 || value > 100) {
        negative = true;
      }
    });
    if (negative) {
      return rowData.find(
        (row) =>
          row.countryId === updatedRow.countryId &&
          row.productId === updatedRow.productId &&
          row.productVarientId === updatedRow.productVarientId,
      );
    } else {
      setRowData((oldRows) => {
        const existingRowIndex = oldRows?.findIndex(
          (row) =>
            row.countryId === updatedRow.countryId &&
            row.productId === updatedRow.productId &&
            row.productVarientId === updatedRow.productVarientId,
        );

        if (existingRowIndex !== -1) {
          // Update the existing row
          return oldRows.map((row, index) => {
            if (index === existingRowIndex) {
              return updatedRow; // Replace with the new row
            }
            return row; // Keep other rows unchanged
          });
        } else {
          // If no row with the same ID exists, simply add the new row
          return [...oldRows, updatedRow];
        }
      });
    }

    setServiceDistributionList([...newArray]);
    return updatedRow;
  };
  const onRowMode = () => {
    setIsRowUpdate(true);
    setIsSaveClicked(false);
  };
  //#endregion
  const [loadingState, setLoadingState] = useState(false);
  return (
    <div>
      <Banner
        Heading={bannerName}
        loading={loadingState}
        Paragraph={bannerDescription}
        showBreadcrumb={true}
        breadcrumbName={breadCrumbName}
      />
      <Container maxWidth="xl">
        <CreateRequestWrapper>
          <div className="createrequestContainer">
            <div className="requestForm">
              <Typography variant="h6">{FormHeading}</Typography>
              {state?.requestType !== "Edit" &&
              crmData?.populationDetails === null ? (
                isCountriesFileUploaded ? (
                  <Box className="requestformLeft">
                    <Button
                      variant="text"
                      className="uploadedFileName"
                      startIcon={
                        <InsertDriveFileOutlinedIcon color="primary" />
                      }
                    >
                      {countryUploadFileName}
                    </Button>
                    <Button
                      component="label"
                      className="replaceFileButton"
                      variant="text"
                      startIcon={<RedoOutlinedIcon color="primary" />}
                    >
                      Replace
                      <VisuallyHiddenInput
                        type="file"
                        onChange={(e) => handleFile(e)}
                      />
                    </Button>
                    |
                    <Button
                      variant="text"
                      className="viewCountriesButton"
                      startIcon={<VisibilityOutlinedIcon color="success" />}
                      onClick={handleViewCountryHeadCountsButtonClick}
                    >
                      View
                    </Button>
                    <a
                      href={UploadCountriesTemplatexlsx}
                      download="Upload-Countries-Template-Excel"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button
                        variant="text"
                        dis
                        className="downloadCountriesUploadTemplateButton"
                        startIcon={<FileDownloadOutlinedIcon color="primary" />}
                      >
                        {Constant.SAMPLE}
                        <Tooltip
                          title={
                            <span className="tooltip">
                              {Constant.TOOLTIP_TITLE}
                            </span>
                          }
                        >
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                      </Button>
                    </a>
                  </Box>
                ) : (
                  <Box className="requestformLeft">
                    {state?.requestType !== "Edit" && (
                      <a
                        href={UploadCountriesTemplatexlsx}
                        download="Upload-Countries-Template-Excel"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Button
                          variant="text"
                          dis
                          className="downloadCountriesUploadTemplateButton"
                          startIcon={
                            <FileDownloadOutlinedIcon color="primary" />
                          }
                        >
                          {Constant.SAMPLE}
                          <Tooltip
                            title={
                              <span className="tooltip">
                                {Constant.TOOLTIP_TITLE}
                              </span>
                            }
                          >
                            <InfoOutlinedIcon className="infoIcon" />
                          </Tooltip>
                        </Button>
                      </a>
                    )}
                    {state?.requestType !== "Edit" && (
                      <Button
                        component="label"
                        className="uploadCountriesButton"
                        variant="contained"
                      >
                        Upload Countries
                        <VisuallyHiddenInput
                          type="file"
                          onChange={(e) => handleFile(e)}
                        />
                      </Button>
                    )}
                  </Box>
                )
              ) : null}
              {(state?.requestType === "Duplicate" ||
                state.requestType === "Create") &&
                crmData?.populationDetails !== null && (
                  <Box className="requestformLeft">
                    <Button
                      variant="text"
                      className="viewCountriesButton"
                      startIcon={<VisibilityOutlinedIcon color="success" />}
                      onClick={handleDuplicateViewCountryHeadCountsButtonClick}
                    >
                      View Countries
                    </Button>
                  </Box>
                )}
            </div>
            {!isValidCountriesUpload && (
              <ValidationAccordionComp
                title={countryValidationTitle}
                subtitle={countryValidationSubTitle}
                headers={countryValidationHeaders}
                rows={countryValidationRows.sort(
                  (a, b) => b.headCount - a.headCount,
                )}
                countries={countryValidationCountries}
                handleConfirm={handleConfirm}
              />
            )}

            {/* CRM DATA Accordion */}
            <AccordionComp
              title={Constant.CRM_DATA}
              subtitle={Constant.ACCORDIAN_SUBTITLE}
              expanded={isAccordianExpanded}
              disabled={isAccordianDisabled}
            >
              {
                //Render in case of Edit
                state?.requestType === "Edit" ? (
                  <Box className="formdataContainer">
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL1}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={crmData.accountName}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL2}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={crmData.oppurtunity}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL3}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={opportunityType}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL4}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={crmData?.billingCountry}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL5}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={crmData.memberOf}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL6}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={crmData.oppurtunityReferrerName}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL7}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={
                          crmData.isBroker === true ||
                          crmData.isBroker === "Yes"
                            ? "Yes"
                            : "No"
                        }
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL8}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={commissionPercentageValue}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL9}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={sumHeadCounts}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL10}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={crmData.currencyCode}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL11}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={crmData.accountSubType}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    {optype?.cpqOpportunityType === "RENEWAL" && (
                      <div className="formdataField">
                        <label>{Constant.CRM_LABEL12}</label>
                        <TextField
                          disabled
                          className="formInput"
                          value={moment(crmData.programStartDate).format(
                            "MM-DD-YYYY",
                          )}
                          InputProps={{
                            classes: { notchedOutline: "noBorder" },
                          }}
                          inputProps={{ className: "noBorder" }}
                        />
                      </div>
                    )}
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL13}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={crmData.ucmsId}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                  </Box>
                ) : (
                  //Render in case of Create/Duplicate
                  <Box className="formdataContainer">
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL1}</label>
                      <TextField
                        disabled
                        className="formInput"
                        defaultValue={crmData.account}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL2}</label>
                      <TextField
                        disabled
                        className="formInput"
                        defaultValue={crmData.opportunity}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL3}</label>
                      <TextField
                        disabled
                        className="formInput"
                        defaultValue={optype?.cpqOpportunityType}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL4}</label>
                      <TextField
                        disabled
                        className="formInput"
                        defaultValue={crmData?.billingCountry}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL5}</label>
                      <TextField
                        disabled
                        className="formInput"
                        defaultValue={crmData.wpo_memberoftext}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL6}</label>
                      <TextField
                        disabled
                        className="formInput"
                        defaultValue={crmData.opportunityReferrerName}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL7}</label>
                      <TextField
                        disabled
                        className="formInput"
                        defaultValue={crmData.isBroker}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL8}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={commissionPercentageValue}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL9}</label>
                      <TextField
                        disabled
                        className="formInput"
                        value={sumHeadCounts}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL10}</label>
                      <TextField
                        disabled
                        className="formInput"
                        defaultValue={crmData.currencyCode}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL11}</label>
                      <TextField
                        disabled
                        className="formInput"
                        defaultValue={crmData.accountSubType}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                    {optype?.cpqOpportunityType === "RENEWAL" && (
                      <div className="formdataField">
                        <label>{Constant.CRM_LABEL12}</label>
                        <TextField
                          disabled
                          className="formInput"
                          defaultValue={moment(crmData.programStartDate).format(
                            "MM-DD-YYYY",
                          )}
                          InputProps={{
                            classes: { notchedOutline: "noBorder" },
                          }}
                          inputProps={{ className: "noBorder" }}
                        />
                      </div>
                    )}
                    <div className="formdataField">
                      <label>{Constant.CRM_LABEL13}</label>
                      <TextField
                        disabled
                        className="formInput"
                        defaultValue={crmData.ucmsId}
                        InputProps={{ classes: { notchedOutline: "noBorder" } }}
                        inputProps={{ className: "noBorder" }}
                      />
                    </div>
                  </Box>
                )
              }
            </AccordionComp>
            {/* end */}

            {/* Quote Detail Accordion */}
            <Box className="secondAccordian">
              <AccordionComp
                title={Constant.QUOTE_DETAILS}
                subtitle={Constant.ACCORDIAN_SUBTITLETWO}
                aria-required
                expanded={isAccordianExpanded}
                disabled={isAccordianDisabled}
              >
                <Box className="formdataContainer">
                  {(optype?.cpqOpportunityType === "NEW" ||
                    ((state?.requestType === "Edit" ||
                      state?.requestType === "Modify") &&
                      opportunityType === "NEW")) && (
                    <div className="formdataFieldOne">
                      <label>
                        {Constant.SECOND_ACCORDIAN_RENEWAL_LABEL1}
                        <span className="red"> *</span>
                        <Tooltip
                          title={
                            <span className="tooltip">{renewalToolTip}</span>
                          }
                        >
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                      </label>
                      <TextField
                        className={`formInputOne ${
                          !errors.existingPartneredClientInfo &&
                          formValues.existingPartneredClientInfo &&
                          "correctInput"
                        }`}
                        placeholder="Type Here"
                        multiline
                        rows={3}
                        name="existingPartneredClientInfo"
                        onChange={handleChange}
                        value={formValues.existingPartneredClientInfo}
                        error={
                          errors.existingPartneredClientInfo ? true : false
                        }
                        inputProps={{ maxLength: 500 }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {errors.existingPartneredClientInfo && (
                                <ErrorOutlineOutlinedIcon
                                  color="error"
                                  fontSize="small"
                                />
                              )}
                              {!errors.existingPartneredClientInfo &&
                                formValues.existingPartneredClientInfo != "" &&
                                formValues.existingPartneredClientInfo >= 0 && (
                                  <CheckIcon fontSize="small" />
                                )}
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Box>
                        {errors.existingPartneredClientInfo && (
                          <span className="error">
                            {errors.existingPartneredClientInfo}
                          </span>
                        )}
                      </Box>
                    </div>
                  )}

                  <div className="formdataFieldTwo">
                    <label>{Constant.SECOND_ACCORDIAN_LABEL1}</label>
                    <Tooltip
                      title={
                        <span className="tooltip">
                          {Constant.TOOLTIP_TITLE1}
                        </span>
                      }
                    >
                      <InfoOutlinedIcon className="infoIcon" />
                    </Tooltip>
                    <TextField
                      className="formInputOne"
                      multiline
                      rows={3}
                      placeholder="Type Here"
                      name="noOfLivesSavedByPartner"
                      onChange={handleChange}
                      value={formValues.noOfLivesSavedByPartner}
                      inputProps={{ maxLength: 500 }}
                    />
                  </div>
                  <div className="formdataFieldTwo">
                    <label>
                      {Constant.SECOND_ACCORDIAN_LABEL2}
                      <span className="red"> *</span>
                    </label>
                    <Tooltip
                      title={
                        <span className="tooltip">
                          {Constant.TOOLTIP_TITLE2}
                        </span>
                      }
                    >
                      <InfoOutlinedIcon className="infoIcon" />
                    </Tooltip>

                    <TextField
                      className={`formInputOne ${
                        !errors.numbercount &&
                        formValues.totalPotentialHeadCountOutside &&
                        "correctInput"
                      }`}
                      onChange={handleChange}
                      multiline
                      rows={3}
                      value={
                        formValues.totalPotentialHeadCountOutside !== ""
                          ? formValues.totalPotentialHeadCountOutside
                          : ""
                      }
                      required
                      name="totalPotentialHeadCountOutside"
                      placeholder="Type Here"
                      error={errors.numbercount ? true : false}
                      inputProps={{ maxLength: 10 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {errors.numbercount && (
                              <ErrorOutlineOutlinedIcon
                                color="error"
                                fontSize="small"
                              />
                            )}
                            {!errors.numbercount &&
                              formValues.totalPotentialHeadCountOutside != "" &&
                              formValues.totalPotentialHeadCountOutside >=
                                0 && <CheckIcon fontSize="small" />}
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box>
                      {errors.numbercount && (
                        <span className="error">{errors.numbercount}</span>
                      )}
                    </Box>
                  </div>

                  <div className="formdataFieldThree">
                    <div className="d-flex">
                      <label>
                        {Constant.SECOND_ACCORDIAN_LABEL3}{" "}
                        <span className="ifapplicable">
                          {Constant.IF_APPLICABLE}
                        </span>
                        <Tooltip
                          title={
                            <span className="tooltip">
                              {Constant.TOOLTIP_TITLE3}
                            </span>
                          }
                        >
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                      </label>
                    </div>
                    {selectedFile == null && (
                      <Button
                        size="medium"
                        component="label"
                        variant="outlined"
                        className="fileButton"
                        onChange={handleFileChange}
                      >
                        Choose File
                        <VisuallyHiddenInput type="file" />
                      </Button>
                    )}
                    {selectedFile != null && (
                      <div className="uploadFile">
                        <p className="fileName" onClick={handledownload}>
                          {selectedFile ? selectedFile : ""}
                        </p>

                        <Button
                          size="medium"
                          component="label"
                          variant="contained"
                          className="fileReButton"
                          onClick={handleReupload}
                        >
                          Re-Upload
                        </Button>
                      </div>
                    )}
                  </div>
                  <div className="formdataFiedlTwoTwo">
                    <label>
                      {Constant.SECOND_ACCORDIAN_LABEL4}{" "}
                      <span className="ifapplicable">
                        {Constant.IF_APPLICABLE}
                      </span>
                    </label>
                    <TextField
                      className="formInputOne"
                      placeholder="Type Here"
                      multiline
                      rows={3}
                      name="formalRFPNotes"
                      onChange={handleChange}
                      value={formValues.formalRFPNotes}
                      inputProps={{ maxLength: 500 }}
                    />
                  </div>
                  <div className="formdataFieldTwo">
                    <label>{Constant.SECOND_ACCORDIAN_LABEL5}</label>
                    <TextField
                      className="formInputOne"
                      placeholder="Type Here"
                      multiline
                      rows={3}
                      name="competitorsBidders"
                      onChange={handleChange}
                      value={formValues.competitorsBidders}
                      inputProps={{ maxLength: 500 }}
                    />
                  </div>
                  {(optype?.cpqOpportunityType === "NEW" ||
                    ((state?.requestType === "Edit" ||
                      state?.requestType === "Modify") &&
                      opportunityType === "NEW")) && (
                    <div className="formdataFieldTwo">
                      <div className="d-flex">
                        <label>
                          {Constant.SECOND_ACCORDIAN_LABEL6}{" "}
                          <span className="red"> *</span>
                          <Tooltip
                            title={
                              <span className="tooltip">
                                {Constant.TOOLTIP_TITLE4}
                              </span>
                            }
                          >
                            <InfoOutlinedIcon className="infoIcon" />
                          </Tooltip>
                        </label>
                      </div>
                      <TextField
                        className={`formInputOne ${
                          !errors.pastquotes &&
                          formValues.pastQuotes &&
                          "correctInput"
                        }`}
                        value={formValues.pastQuotes}
                        onChange={handleChange}
                        name="pastQuotes"
                        multiline
                        rows={3}
                        error={errors.pastquotes ? true : false}
                        placeholder="Type Here"
                        inputProps={{ maxLength: 500 }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {errors.pastquotes && (
                                <ErrorOutlineOutlinedIcon
                                  color="error"
                                  className="red"
                                  fontSize="small"
                                />
                              )}
                              {!errors.pastquotes && formValues.pastQuotes && (
                                <CheckIcon color="success" fontSize="small" />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Box>
                        {errors.pastquotes && (
                          <span className="error">{errors.pastquotes}</span>
                        )}
                      </Box>
                    </div>
                  )}
                  {(optype?.cpqOpportunityType === "NEW" ||
                    ((state?.requestType === "Edit" ||
                      state?.requestType === "Modify") &&
                      opportunityType === "NEW")) && (
                    <div className="formdataFieldTwo">
                      <div className="d-flex">
                        <label>
                          {Constant.SECOND_ACCORDIAN_LABEL7}
                          <span className="ifapplicable">
                            {Constant.IF_APPLICABLE}
                          </span>
                          <span className="red"> *</span>
                          <Tooltip
                            title={
                              <span className="tooltip">
                                {Constant.TOOLTIP_TITLE5}
                              </span>
                            }
                          >
                            <InfoOutlinedIcon className="infoIcon" />
                          </Tooltip>
                        </label>
                      </div>
                      <TextField
                        className={`formInputOne ${
                          !errors.currentutlization &&
                          formValues.currentUtilizationWithOtherVendors &&
                          "correctInput"
                        }`}
                        value={formValues.currentUtilizationWithOtherVendors}
                        onChange={handleChange}
                        name="currentUtilizationWithOtherVendors"
                        placeholder="Type Here"
                        multiline
                        rows={3}
                        error={errors.currentutlization ? true : false}
                        inputProps={{ maxLength: 500 }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {errors.currentutlization && (
                                <ErrorOutlineOutlinedIcon
                                  color="error"
                                  fontSize="small"
                                />
                              )}
                              {!errors.currentutlization &&
                                formValues.currentUtilizationWithOtherVendors && (
                                  <CheckIcon color="success" fontSize="small" />
                                )}
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Box>
                        {errors.currentutlization && (
                          <span className="error">
                            {errors.currentutlization}
                          </span>
                        )}
                      </Box>
                    </div>
                  )}
                  {
                    <div className="formdataFieldThree">
                      <label>
                        {Constant.SECOND_ACCORDIAN_LABEL8}{" "}
                        <span className="red"> *</span>
                        <Tooltip
                          title={
                            <span className="tooltip">
                              {Constant.TOOLTIP_TITLE8}
                            </span>
                          }
                        >
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                      </label>
                      <TextField
                        type="date"
                        className={`formInputTwdoate ${
                          !errors.deadlineDate &&
                          formValues.deadline &&
                          "correctInput"
                        }`}
                        value={formValues.deadline}
                        onChange={handleChange}
                        onKeyDown={(event) => {
                          event.preventDefault();
                        }}
                        name="deadline"
                        error={errors.deadlineDate ? true : false}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {errors.deadlineDate && (
                                <ErrorOutlineOutlinedIcon
                                  color="error"
                                  fontSize="small"
                                />
                              )}
                              {!errors.deadlineDate && formValues.deadline && (
                                <CheckIcon color="success" fontSize="small" />
                              )}
                            </InputAdornment>
                          ),
                        }}
                        inputProps={{
                          min: getFormattedToday(), // You need to define getFormattedToday() function to get today's date in the correct format (YYYY-MM-DD).
                        }}
                      />

                      <Box>
                        {errors.deadlineDate && (
                          <span className="error">{errors.deadlineDate}</span>
                        )}
                      </Box>
                    </div>
                  }
                  <div className="formdataFieldThree">
                    <label>
                      {Constant.SECOND_ACCORDIAN_LABEL9}
                      <span className="red"> *</span>
                      <Tooltip
                        title={
                          <span className="tooltip">{NoOfRamsToolTip}</span>
                        }
                      >
                        <InfoOutlinedIcon className="infoIcon" />
                      </Tooltip>
                    </label>
                    <TextField
                      className={`formInputThree ${
                        !errors.numberram &&
                        formValues.noOfRAMs &&
                        "correctInput"
                      }`}
                      onChange={handleChange}
                      value={
                        formValues.noOfRAMs !== "" ? formValues.noOfRAMs : ""
                      }
                      name="noOfRAMs"
                      error={errors.numberram}
                      placeholder="Type Here"
                      inputProps={{ maxLength: 10 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {errors.numberram && (
                              <ErrorOutlineOutlinedIcon
                                color="error"
                                fontSize="small"
                              />
                            )}
                            {!errors.numberram &&
                              formValues.noOfRAMs != "" &&
                              formValues.noOfRAMs >= 0 && (
                                <CheckIcon color="success" fontSize="small" />
                              )}
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box>
                      {errors.numberram && (
                        <span className="error">{errors.numberram}</span>
                      )}
                    </Box>
                  </div>
                  <div className="formdataFieldTwo">
                    <div className="d-flex">
                      <label>
                        {Constant.SECOND_ACCORDIAN_LABEL10}
                        <Tooltip
                          title={
                            <span className="tooltip">
                              {Constant.TOOLTIP_TITLE7}
                            </span>
                          }
                        >
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                      </label>
                    </div>
                    <TextField
                      className="formInputOne"
                      placeholder="Type Here"
                      value={formValues.locationRAMs}
                      onChange={handleChange}
                      multiline
                      rows={3}
                      inputProps={{ maxLength: 500 }}
                      name="locationRAMs"
                    />
                  </div>
                  {(optype?.cpqOpportunityType === "RENEWAL" ||
                    ((state?.requestType === "Edit" ||
                      state?.requestType === "Modify") &&
                      opportunityType === "RENEWAL")) && (
                    <div className="formdataFieldTwo">
                      <label>
                        {Constant.SECOND_ACCORDIAN_RENEWAL_LABEL2}
                        <span className="red"> *</span>
                      </label>
                      <TextField
                        className="formInputOne"
                        placeholder="Type Here"
                        multiline
                        rows={3}
                        name="currentRateEffectiveOn"
                        onChange={handleChange}
                        inputProps={{ maxLength: 500 }}
                        value={formValues.currentRateEffectiveOn}
                      />
                      <Box>
                        {errors.currentRateEffectiveOn && (
                          <span className="error">
                            {errors.currentRateEffectiveOn}
                          </span>
                        )}
                      </Box>
                    </div>
                  )}
                  {(optype?.cpqOpportunityType === "RENEWAL" ||
                    ((state?.requestType === "Edit" ||
                      state?.requestType === "Modify") &&
                      opportunityType === "RENEWAL")) && (
                    <div className="formdataFieldTwo">
                      <label>
                        {Constant.SECOND_ACCORDIAN_RENEWAL_LABEL3}
                        <span className="ifapplicable">
                          {Constant.IF_APPLICABLE}
                        </span>
                      </label>
                      <TextField
                        className="formInputOne"
                        placeholder="Type Here"
                        multiline
                        rows={3}
                        name="pastThreeYrRateHeadCount"
                        onChange={handleChange}
                        inputProps={{ maxLength: 500 }}
                        value={formValues.pastThreeYrRateHeadCount}
                      />
                    </div>
                  )}

                  {/*Field no longer required - Sofia's email Friday, January 5, 2024 9:23 PM*/}

                  {/*{optype?.cpqOpportunityType === "RENEWAL" && (*/}
                  {/*    <div className="formatdataFieldFive">*/}
                  {/*        <label>{Constant.SECOND_ACCORDIAN_RENEWAL_LABEL5}</label>*/}

                  {/*        <TextField*/}
                  {/*            className="formInputTwo"*/}
                  {/*            placeholder="Type Here"*/}
                  {/*            multiline rows={3}*/}
                  {/*            name="estimatedNoOfAMHrPerYear"*/}
                  {/*            onChange={handleChange}*/}
                  {/*            inputProps={{ maxLength: 500 }}*/}
                  {/*            value={formValues.estimatedNoOfAMHrPerYear}*/}
                  {/*        />*/}
                  {/*    </div>*/}
                  {/*)}*/}
                  {(optype?.cpqOpportunityType === "RENEWAL" ||
                    ((state?.requestType === "Edit" ||
                      state?.requestType === "Modify") &&
                      opportunityType === "RENEWAL")) && (
                    <div className="formdataFieldTwo">
                      <div className="d-flex">
                        <label>
                          {Constant.SECOND_ACCORDIAN_RENEWAL_LABEL4}
                          <Tooltip
                            title={
                              <span className="tooltip">
                                {Constant.TOOLTIP_TITLE11}
                              </span>
                            }
                          >
                            <InfoOutlinedIcon className="infoIcon" />
                          </Tooltip>
                        </label>
                      </div>

                      <TextField
                        className="formInputOne"
                        placeholder="Type Here"
                        multiline
                        rows={3}
                        name="annualUtilizationThreeYrs"
                        onChange={handleChange}
                        inputProps={{ maxLength: 500 }}
                        value={formValues.annualUtilizationThreeYrs}
                      />
                    </div>
                  )}

                  <div className="formdataFieldTwo">
                    <label>
                      {Constant.SECOND_ACCORDIAN_LABEL11}{" "}
                      <span className="red"> *</span>
                      <Tooltip
                        title={
                          <span className="tooltip">{samPricingToolTip}</span>
                        }
                      >
                        <InfoOutlinedIcon className="infoIcon" />
                      </Tooltip>
                      <TextField
                        className={`formInputOne ${
                          !errors.sampricing &&
                          formValues.samPriceRecommendAssumption &&
                          "correctInput"
                        }`}
                        value={formValues.samPriceRecommendAssumption}
                        onChange={handleChange}
                        name="samPriceRecommendAssumption"
                        placeholder="Type Here"
                        multiline
                        rows={3}
                        inputProps={{ maxLength: 500 }}
                        error={errors.sampricing ? true : false}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {errors.sampricing && (
                                <ErrorOutlineOutlinedIcon
                                  color="error"
                                  fontSize="small"
                                />
                              )}
                              {!errors.sampricing &&
                                formValues.samPriceRecommendAssumption && (
                                  <CheckIcon color="success" fontSize="small" />
                                )}
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Box>
                        {errors.sampricing && (
                          <span className="error">{errors.sampricing}</span>
                        )}
                      </Box>
                    </label>
                  </div>

                  <div className="formdataFieldThree">
                    <label>
                      {Constant.SECOND_ACCORDIAN_LABEL12}{" "}
                      <span className="red"> *</span>
                    </label>
                    <div className="inputSelect">
                      <FormControl className="customDropdown">
                        <Select
                          value={formValues.productId}
                          name="productId"
                          onChange={handleSelectChange}
                          placeholder="Select Product"
                        >
                          <MenuItem divider value={0} disabled>
                            Select Product
                          </MenuItem>
                          {productsList.map((option) => (
                            <MenuItem divider key={option.id} value={option.id}>
                              {option.productName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <Box>
                        {errors.selectedOption && (
                          <span className="error">{errors.selectedOption}</span>
                        )}
                      </Box>
                    </div>
                  </div>
                  <div className="formdataFieldThree">
                    <label>
                      {Constant.SECOND_ACCORDIAN_LABEL13}{" "}
                      {Object.values(CalculatedProducts).includes(
                        formValues.productId,
                      ) &&
                        formValues.productId !== 0 &&
                        isProductNotLikeBOH(formValues.productId) &&
                        formValues.productId !==
                          AllProductsEnum.ENHANCEDLEGALSERVICES &&
                        formValues.productId !==
                          AllProductsEnum.ENHANCEDFINANCIALSERVICES && (
                          <span className="red">*</span>
                        )}
                    </label>
                    <div className="inputSelect">
                      <FormControl className="customDropdown">
                        <Select
                          value={formValues.productVariationId}
                          name="productVariationId"
                          onChange={handleSelectChange}
                          disabled={productVariationsList.length <= 0}
                        >
                          <MenuItem divider value={0} disabled>
                            Select Product Variation
                          </MenuItem>
                          {productVariationsList.map((option) => (
                            <MenuItem divider key={option.id} value={option.id}>
                              {option.productVariationName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <Box>
                        {errors.productVariationOption && (
                          <span className="error">
                            {errors.productVariationOption}
                          </span>
                        )}
                      </Box>
                    </div>
                  </div>
                  <div className="formdataFieldThree">
                    <label>
                      {Constant.SECOND_ACCORDIAN_LABEL14}{" "}
                      {<span className="red">*</span>}
                    </label>
                    <div className="inputSelect">
                      <TextField
                        className="formInputFour"
                        type="number"
                        value={formValues.numberOfYears === "" ? "" : (formValues.numberOfYears ?? 1)}
                        onChange={handleChange}
                        onBlur={handleNumberOfYearsBlur}
                        inputProps={{ min: 1, max: 10 }}
                        name="numberOfYears"
                        placeholder="Type Here"
                        sx={{ mt: 1.2 }}
                      />
                      <Box>
                        {errors.numberOfYears && (
                          <span className="error">
                            {errors.numberOfYears}
                          </span>
                        )}
                      </Box>
                    </div>
                  </div>
                </Box>
              </AccordionComp>
            </Box>
            {/* End */}

            {/* Variation Accordian */}

            <Box className="thirdAccordian">
              {showVariationAccordian && formValues.productId != 0 && (
                <AccordionComp
                  title="Variation"
                  expanded={isAccordianExpanded}
                  disabled={isAccordianDisabled}
                >
                  {/* {(variationType <= 3 && componentList.length > 0) && */}
                  {componentList.length > 0 && (
                    <div className="thirdAccordianContainer">
                      <Typography variant="h6">
                        {Constant.COMPONENTS}
                      </Typography>
                      <Box className="d-flex">
                        {componentList.map((x) => (
                          <FormGroup
                            className={x.checked ? "selected" : "checkboxInput"}
                            key={x.id}
                          >
                            <FormControlLabel
                              title={x.componentName}
                              control={
                                <Checkbox
                                  onChange={handleInputChanges}
                                  name={x.id}
                                  checked={x.checked}
                                  disabled={x.disabled}
                                />
                              }
                              label={x.componentName}
                            />
                          </FormGroup>
                        ))}
                      </Box>
                      <Box className="d-flex">
                        {errors.component && (
                          <span className="error">{errors.component}</span>
                        )}
                      </Box>
                    </div>
                  )}
                  <div className="d-flex accordianBottom">
                    {fieldIsVisible.SESSION && (
                      // (variationType <= 1) &&
                      <Box className="bottomInputs">
                        <label>
                          {Constant.SESSION}
                          {Object.values(CalculatedProducts).includes(
                            formValues.productId,
                          ) && <span className="red"> *</span>}
                        </label>

                        <TextField
                          className="formInputFour"
                          value={
                            formValues.sessions === 0 ? "" : formValues.sessions
                          }
                          onChange={handleChange}
                          disabled={
                            formValues.productId ===
                              AllProductsEnum.EVOLUTION ||
                            formValues.productId === AllProductsEnum.WORKLIFE ||
                            formValues.productId ===
                              AllProductsEnum.ENHANCEDLEGALSERVICES ||
                            formValues.productId ===
                              AllProductsEnum.ENHANCEDFINANCIALSERVICES
                          }
                          inputProps={{ maxLength: 2 }}
                          placeholder="Type Here"
                          name="sessions"
                        />
                        <Box>
                          {errors.session && (
                            <span className="error">{errors.session}</span>
                          )}
                        </Box>
                      </Box>
                    )}

                    {isUtilizationChanged && (
                      <Box className="bottomInputs">
                        <label>{Constant.UTILIZATION}</label>
                        <TextField
                          className="formInputFour"
                          value={countryUtilizationVariation?.toLocaleString(
                            "en",
                            {
                              useGrouping: true,
                              roundingMode: "trunc",
                              maximumFractionDigits: 2,
                            },
                          )}
                          disabled={true}
                          inputProps={{ maxLength: 10 }}
                          name="utilization"
                          placeholder="Type Here"
                        />
                      </Box>
                    )}

                    {!isUtilizationChanged && fieldIsVisible.UTILIZATION && (
                      // (variationType <= 2) &&
                      <Box className="bottomInputs">
                        <label>
                          {Constant.UTILIZATION}
                          {Object.values(CalculatedProducts).includes(
                            formValues.productId,
                          ) && <span className="red"> *</span>}
                        </label>
                        <TextField
                          className="formInputFour"
                          value={
                            formValues.utilization === 0
                              ? ""
                              : formValues.utilization
                          }
                          onChange={handleChange}
                          inputProps={{ maxLength: 10 }}
                          name="utilization"
                          placeholder="Type Here"
                        />
                        <Box>
                          {errors.utilization && (
                            <span className="error">{errors.utilization}</span>
                          )}
                        </Box>
                      </Box>
                    )}

                    {((formValues.oppurtunityType === "RENEWAL" &&
                      isProductNotLikeBOH(formValues.productId)) ||
                      (fieldIsVisible.AMHOURS &&
                        formValues.oppurtunityType === "NEW" &&
                        !Object.values(CalculatedProducts).includes(
                          formValues.productId,
                        ) &&
                        !(
                          formValues.quoteStatusId === 0 ||
                          formValues.quoteStatusId === QuoteStatus.SAVEASDRAFT
                        )) ||
                      (fieldIsVisible.AMHOURS &&
                        formValues.oppurtunityType === "NEW" &&
                        !(
                          formValues.quoteStatusId === 0 ||
                          formValues.quoteStatusId === QuoteStatus.SAVEASDRAFT
                        ) &&
                        state?.requestType === "Edit" &&
                        (loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM ||
                          loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER ||
                          loggedUser?.userRole[0]?.id === UserRole.PRICINGVP ||
                          loggedUser?.userRole[0]?.id ===
                            UserRole.SAMLEADERSHIPTEAM ||
                          loggedUser?.userRole[0]?.id ===
                            UserRole.SAMLEADERSHIPTEAMLEVEL3) &&
                        isProductNotLikeBOH(formValues.productId))) && (
                      <Box className="bottomInputs">
                        <label>
                          {Constant.AMHOURS}
                          {Object.values(CalculatedProducts).includes(
                            formValues.productId,
                          ) && <span className="red"> *</span>}
                        </label>
                        <TextField
                          className="formInputFour"
                          value={formValues.amHours}
                          inputProps={{ maxLength: 5 }}
                          onChange={handleChange}
                          name="amHours"
                        />
                        <Box>
                          {errors.amHours && (
                            <span className="error">{errors.amHours}</span>
                          )}
                        </Box>
                      </Box>
                    )}
                    {fieldIsVisible.HOURS &&
                      // (variationType===1||variationType===2||variationType===3)
                      formValues.productId != 1 && (
                        <Box className="bottomInputs">
                          <label>
                            {Constant.HOURS}
                            {((isProductLikeBOH(formValues.productId) &&
                              isConsultingITDevShowCalculate) ||
                              (formValues.productId ===
                                AllProductsEnum.RETURNTOWORK_CANCERCARECOMPASS &&
                                formValues.pricingStructureId ===
                                  PricingStructuresEnum.FLATFEE_BANKOFCASES)) && (
                              <span className="red"> *</span>
                            )}
                          </label>

                          <TextField
                            className="formInputFour"
                            value={formValues.hours}
                            inputProps={{ maxLength: 10 }}
                            onChange={handleChange}
                            name="hours"
                          />
                          <Box>
                            {errors.hours && (
                              <span className="error">{errors.hours}</span>
                            )}
                          </Box>
                        </Box>
                      )}
                    {fieldIsVisible.SEATCOUNT &&
                      // (variationType===1||variationType===2||variationType===3)
                      formValues.productId != 1 && (
                        <Box className="bottomInputs">
                          <label>
                            {Constant.SEATCOUNT}
                            <Tooltip
                              title={
                                <span className="tooltip">
                                  {Constant.TOOLTIP_TITLE9}
                                </span>
                              }
                            >
                              <InfoOutlinedIcon className="infoIcon" />
                            </Tooltip>
                          </label>
                          <TextField
                            className="formInputFour"
                            value={
                              formValues.seatCount == 0
                                ? ""
                                : formValues.seatCount
                            }
                            inputProps={{ maxLength: 5 }}
                            onChange={handleChange}
                            name="seatCount"
                          />
                        </Box>
                      )}
                    {fieldIsVisible.DISCOUNT && (
                      <Box className="bottomInputs">
                        <label>
                          {Constant.DISCOUNT}
                          <Tooltip
                            title={
                              <span className="tooltip">{DiscountToolTip}</span>
                            }
                          >
                            <InfoOutlinedIcon className="infoIcon" />
                          </Tooltip>
                        </label>
                        <TextField
                          className="formInputFour"
                          value={formValues.discount}
                          inputProps={{ maxLength: 10 }}
                          onChange={handleChange}
                          name="discount"
                        />
                        <Box>
                          {errors.discount && (
                            <span className="error">{errors.discount}</span>
                          )}
                        </Box>
                      </Box>
                    )}

                    {fieldIsVisible.BUNDLEDISCOUNT && (
                      <Box className="bottomInputs">
                        <label>
                          {Constant.BUNDLEDISCOUNT}
                          <Tooltip
                            title={
                              <span className="tooltip">
                                {BundleDiscountToolTip}
                              </span>
                            }
                          >
                            <InfoOutlinedIcon className="infoIcon" />
                          </Tooltip>
                        </label>
                        <TextField
                          className="formInputFour-disabled"
                          value={formValues.bundleDiscount}
                          name="bundlediscount"
                          disabled
                        />
                      </Box>
                    )}

                    {fieldIsVisible.PRICINGSTRUCTURE && (
                      <Box className="bottomInputs">
                        <label>
                          {Constant.PRICING_STRUCTURE}
                          <span className="red"> *</span>
                        </label>
                        <div className="bottomInputSelect">
                          <FormControl className="customDropdown">
                            <Select
                              value={formValues.pricingStructureId}
                              name="pricingStructureId"
                              onChange={handleSelectChange}
                            >
                              <MenuItem disabled value={0}>
                                Select Pricing Structure
                              </MenuItem>
                              {pricingStructureList.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                  {option.pricingStructureName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {errors.pricingOption && (
                            <span className="error">
                              {errors.pricingOption}
                            </span>
                          )}
                        </div>
                      </Box>
                    )}

                    {((fieldIsVisible.ADDITIONALNOTES &&
                      isProductLikeBOH(formValues.productId)) ||
                      (fieldIsVisible.ADDITIONALNOTES &&
                        !Object.values(CalculatedProducts).includes(
                          formValues.productId,
                        ))) && (
                      // (variationType === 0) &&
                      <Box className="bottomLongInputs">
                        <label>
                          {Constant.ADDITIONALNOTES}
                          <span className="red"> *</span>
                        </label>
                        <TextField
                          multiline
                          rows={3}
                          className="formInputFour"
                          value={formValues.additionalNotes}
                          inputProps={{ maxLength: 500 }}
                          onChange={handleChange}
                          name="additionalNotes"
                        />
                        <Box>
                          {errors.additionalNotes && (
                            <span className="error">
                              {errors.additionalNotes}
                            </span>
                          )}
                        </Box>
                      </Box>
                    )}
                  </div>
                  {Object.values(CalculatedProducts).includes(
                    formValues.productId,
                  ) &&
                    isConsultingITDevShowCalculate && (
                      <Box
                        className="bottomInputButton"
                        sx={{ display: "flex", width: "90%" }}
                      >
                        <CustomButton
                          buttonName={
                            calculateBtnLoading
                              ? "Calculating.."
                              : Constant.CALCULATE
                          }
                          onClick={handleCalculateClick}
                          disabled={calculateBtnLoading}
                          color="success"
                        ></CustomButton>
                        {calculateBtnLoading && (
                          <CircularProgress
                            size={24}
                            sx={{
                              color: green[50],
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              marginTop: "-5px",
                              marginLeft: "-12px",
                            }}
                          />
                        )}
                      </Box>
                    )}
                </AccordionComp>
              )}
            </Box>

            {/* end */}
          </div>
          {state?.requestType === "Create" &&
            crmData?.populationDetails === null &&
            !isCountriesFileUploaded && (
              <div className="imageContainer">
                <img
                  src={nodataimage}
                  className="noimage"
                  alt="No Data Image"
                />
                <div className="noimagetext">{Constant.NODATA}</div>
              </div>
            )}
        </CreateRequestWrapper>

        {/* Utilization Distribution Table */}
        {Object.values(CalculatedProducts).includes(formValues.productId) &&
          formValues.productVariationId !== 0 &&
          utilizationDistributionCountries.length > 0 && (
            <ViewBoxWrapper>
              <Box className="viewTableContainer">
                <div className="d-flex">
                  <div className="d-flex titleDiv">
                    <Typography variant="h4">
                      {Constant.UTILIZATION_DISTRIBUTION}
                    </Typography>
                  </div>
                  {!isDistributionEditable ? (
                    (formValues.oppurtunityType === "RENEWAL" ||
                      loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM ||
                      loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER ||
                      loggedUser?.userRole[0]?.id === UserRole.PRICINGVP ||
                      state?.requestType === "Modify") &&
                    utilizationDistributionRows.length > 0 && (
                      <div className="editBtn">
                        <CustomButton
                          buttonName={Constant.EDIT}
                          icon={ModeEditIcon}
                          color="primary"
                          className="editBtn"
                          onClick={handleEditButtonClick}
                        />
                      </div>
                    )
                  ) : (
                    <div className="buttonAlign">
                      <CustomButton
                        buttonName={Constant.SAVE}
                        icon={SaveIcon}
                        color="success"
                        onClick={handleSaveClick}
                      />
                    </div>
                  )}
                </div>
              </Box>

              {
                <Box className="viewTableContent">
                  {rowData?.length != 0 && (
                    <ServiceDistribution
                      searchText={searchQuery}
                      headers={headerData}
                      reload={renderKey}
                      utilizationDistributionRows={rowData}
                      handleUpdate={onRowChange}
                      handleRowMode={onRowMode}
                      ComponentData={editableComponentData}
                    />
                  )}
                </Box>
              }
            </ViewBoxWrapper>
          )}

        {/* Non Eap  Table */}
        {(loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM ||
          loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER ||
          loggedUser?.userRole[0]?.id === UserRole.PRICINGVP) &&
          formValues.productId > 0 &&
          (!Object.values(CalculatedProducts).includes(formValues.productId) ||
            //BOH specific show/hide
            (formValues.productId ===
              AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS &&
              isConsultingITDevShowNonEAPGrid)) && (
            <ViewBoxWrapper>
              <Box className="viewTableContainer">
                <div className="d-flex">
                  <Typography variant="h4">{Constant.OTHERPRODUCT}</Typography>
                  {!isNonEapEditable ? (
                    <div className="editBtn">
                      <CustomButton
                        buttonName={Constant.EDIT}
                        icon={ModeEditIcon}
                        color="primary"
                        className="editBtn"
                        onClick={handleNonEapEditButtonClick}
                      />
                    </div>
                  ) : (
                    <div className="buttonAlign">
                      <CustomButton
                        buttonName={Constant.SAVE}
                        icon={SaveIcon}
                        color="success"
                        onClick={handleNonEapSaveButtonClick}
                      />
                    </div>
                  )}
                </div>
              </Box>
              {
                <Box className="viewTableContent2">
                  {nonEapRowData && (
                    <UtilizationDistribution
                      headers={nonEapHeader}
                      rows={nonEapRowData}
                      isEditable={isNonEapEditable}
                      onTextChange={onChange}
                    />
                  )}
                </Box>
              }
            </ViewBoxWrapper>
          )}
        <div ref={inputRef}>
          {pricingStructureVal !== "" && formValues.productId != 0 && (
            <CalculationWrapper>
              <Box className="calculationContainer">
                <Typography variant="h4">
                  {Constant.PRICING_CALCULATION}{" "}
                  <span>{Constant.ALL_IN_PRICE}</span>
                </Typography>
                <div className="calculationContent">
                  {!allInPriceLoading && (
                    <div className="d-flex">
                      <div className="heading">
                        <Typography variant="h6">
                          {pricingStructureLbl}
                        </Typography>
                        <span style={{ fontWeight: 600 }}>
                          {pricingStructureVal.toLocaleString()}
                        </span>
                      </div>
                      <div className="heading">
                        <Typography variant="h6">
                          {pricingStructureUSDLbl}
                        </Typography>
                        <span style={{ fontWeight: 600 }}>
                          {pricingStructureUSDVal.toLocaleString()}
                        </span>
                      </div>
                      <div className="heading">
                        <Typography variant="h6">{Constant.TCVCAD}</Typography>
                        <span style={{ fontWeight: 600 }}>
                          {tcvCad.toLocaleString()}
                        </span>
                      </div>
                    </div>
                  )}
                  {allInPriceLoading && (
                    <div
                      style={{
                        display: "flex",
                        justifycontent: "center",
                        alignitems: "center",
                        zIndex: 1300,
                      }}
                    >
                      {allInPriceLoading && (
                        <Box sx={{ width: "100%" }}>
                          <CircularProgress size={24} />
                          <Typography variant="subtitle2" gutterBottom>
                            {loadingText}
                          </Typography>
                        </Box>
                      )}
                    </div>
                  )}
                </div>
              </Box>
              {/* <div style={{ marginBottom: '150px' }} ></div> */}
            </CalculationWrapper>
          )}
        </div>
      </Container>
      <div style={{ marginTop: "150px" }}></div>
      <Box>
        <FooterButtons
          leftButton={Constant.GO_BACK}
          onGoback={handleGoback}
          onSubmitButton={handleSubmit}
          onRightButtonClick={handleSaveAsDraft}
          rightButtonTextOne={Constant.SAVE_DRAFT}
          leftButtonTextTwo={Constant.SUBMIT_VIEW}
          quoteStatus={currentQuoteStatusId}
          requestType={state.requestType}
          userRole={loggedUser?.userRole[0]?.id}
          pricingTeamApproveRejectDiscount={isPricingTeamApproveRejectDiscount}
          showButtons={showButtons}
          loading={submitLoading}
          draftLoading={draftLoading}
        />
      </Box>
      {showNotification && (
        <Notification
          open={showNotification}
          onClose={closeNotificationPopup}
          message={notificationMessage}
          severity={notificationSeverity}
        />
      )}
      {showCountryHeadCountDialog && (
        <SimpleDialog
          headers={countryHeadCountDialogHeaders}
          rows={countryHeadCountDialogRows.sort(
            (a, b) => b.headcount - a.headcount,
          )}
          open={showCountryHeadCountDialog}
          close={closeCountryHeadCountDialog}
        />
      )}
      {showCountryDialog && (
        <ViewCountryDialog
          headers={countryHeadCountDialogHeaders}
          rows={countryHeadCountDialogRows.sort(
            (a, b) => b.headcount - a.headcount,
          )}
          open={showCountryDialog}
          close={closeDuplicateCountryHeadCountDialog}
          handleChange={handleCountryChanges}
          remove={SaveCountryHeadCount}
          handleTextboxChange={handleTextboxHeadCountChange}
          handleSelectChange={handleSelectCountryChange}
          headcountError={newHeadcountError}
          countryError={newCountryError}
          countries={allCountrylist}
          newCountry={newCountryHeadCount}
          loadingState={loadingState}
        />
      )}
      {showConfirmation && (
        <ConfirmationBox
          show={showConfirmation}
          title={Constant.CONFIRM}
          heading={Constant.FLOORMARGINPOPUP}
          handleConfirmClick={handleConfirmSubmitPopup}
          handleCancelClick={closConfirmationPopup}
        />
      )}
      {loadingState && <Loader open={loadingState} />}
      {quoteLoader && <Loader open={quoteLoader} />}
    </div>
  );
};

export default QuoteRequest;
